export default {
    "type": "FeatureCollection",
    "features": [
        {
            "id": "710000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@°Ü¯Û"
                    ],
                    [
                        "@@ƛĴÕƊÉɼģºðʀ\\ƎsÆNŌÔĚä\u009cnÜƤɊĂǀĆĴ\u009eĤǊŨxĚĮǂƺòƌ\u0082\u0096âÔ®ĮXŦţƸ\u007fZûÐ\u008bƕƑGđ¨ĭMó·ęcëƝɉlÝƯֹÅŃ^Ó·\u008f\u009dśŃǋƏď\u008díåɛGɉ\u0099¿@ăƑ\u008e¥ĘWǬÏĶŁâ"
                    ],
                    [
                        "@@\\p|WoYG¿¥I\u0086j@¢"
                    ],
                    [
                        "@@\u0085¡\u0089@\u0081\u0088V^Rq\u0088B\u0081bA\u008cnTXeRz¤L\u009e«³I"
                    ],
                    [
                        "@@ÆEE\u0097\u0084kWqë @\u009c"
                    ],
                    [
                        "@@fced"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            122886,
                            24033
                        ]
                    ],
                    [
                        [
                            123335,
                            22980
                        ]
                    ],
                    [
                        [
                            122375,
                            24193
                        ]
                    ],
                    [
                        [
                            122518,
                            24117
                        ]
                    ],
                    [
                        [
                            124427,
                            22618
                        ]
                    ],
                    [
                        [
                            124862,
                            26043
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    121.509062,
                    24.044332
                ],
                "name": "台湾",
                "childNum": 6
            }
        },
        {
            "id": "130000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@o~\u0086Z]\u0082ªr\u0089ºc_ħ²G¼s`jÎŸnüsÂ\u009cłNX_\u0093M`Ç½ÓnUK\u0085Ĝ\u0081ēs¤\u00ad©yrý§uģ\u008c\u008fc\u007f\u0086J\u008a\u009be"
                    ],
                    [
                        "@@U`Ts¿mÂ\u0082"
                    ],
                    [
                        "@@oºƋÄd\u0096eV\u008eDJj£\u0080J|ÅdzÂ\u0095Ft~\u009eKŨ¸IÆv|\u0094\u0087¢r}è\u0086\u008eonb\u0098}`RÎÄn°ÒdÞ²\u0084^®\u0092lnÐèĄlðÓ\u009c×]ªÆ}\u0090\u008dLiĂ±Ö\u008f`^°Ç¶p®đDc\u009cŋ`\u008d\u0096ZÔ\u007f\u0092¶êqvFÆ\u009a\u0086N®ĆTH®¦O\u0092¾\u008aIbÐã´BĐɢŴÆíȦp\u0096ĐÞXR\u0080·nndO\u009e¤\u0092OÀĈƒ\u00adQg\u0098µFo|gȒęSWb©osx|hYh\u0095gŃfmÖĩnº\u0080TÌ\u0092Sp\u009b¢dYĤ¶UĈjl\u0092ǐpäìë|³kÛfw²Xj\u007fz~ÂqbT\u008aÑ\u0084ěŨ@|oM\u0087\u0092zv\u007f¢ZrÃVw¬ŧĖ¸f\u008c°ÐT\u0080ªq\u008es{S\u009e¯r æÝlNd®²Ğ ǆiGĘ\u0082J\u0099¼lr}~K¨ŸƐÌWö\u0080\u0099Æ\u008azR\u009a¤lêmĞLÎ\u0084\u0092\u009d@¡|q]SvK\u0080ÑcwpÏÏ\u0081\u0086Ŀ\u008fćènĪW\u0090lĄkT}\u0088J\u0094¤~\u0083ÈT\u0081\u0084d\u0084\u0099pddʾĬ\u008a\u0094\u008eBVt\u0084EÀ¢ôPĎƗè@~\u0082k\u0096ü\\rÊĔÖæW_§¼F\u0098\u0086´©òDòj\u0090\u0092\u0088YÈrbĞāøŀG{ƀ|¦ðrb|ÀH`pʞkv\u0082GpuARhÞÆǶgĘ\u008aT\u008fǼƹS£¨¡ù³ŘÍ]¿Ây\u008d\u0099ôEP xX¶\u008f¹\u007fÜ\u0087O¡\u0093gÚ¡IwÃé\u0091¦ÅB\u0087Ï|Ç°\u0085N«úmH¯\u009d\u008bâ\u009fDù\u008eyŜ\u009eŲIÄuĐ¨D\u0081\u009e\u0095¸dɂ\u0087\u0090\u0082F\u009f\u0083\u0095\u009bOh\u0087đ©O\u009f\u009biÃ`ww^\u0083Ìk\u009f\u0091ÑH«ƇǤŗĺtFu\u0085{Z}Ö@U\u0087´\u0085ʚLg\u007f®¯Oı°Ãw\u009f ^\u0098\u0097\u0080VbÉs\u0087\u0088mA\u0085ê]]w\u0084§\u009bRRl£\u0087ȭµu¯b{ÍDěïÿȧ\u008euT£ġ\u0083ěŗƃĝ\u0093Q¨fV\u0086Ƌ\u0095ƅn\u00ada@\u0091³@\u009aď\u0084yÃ½\u008fIĹÊK\u009aŭfċŰó\u008cxV@t\u008d\u0088Ư\u008cJ\u0094]e\u0083R¾fe|rHA\u0098|h~Ėƍl§Ï\u007f\u008alTíb Øo\u0088Åbbx³^z\u0090ÃĶ\u009a¶Sj®A\u0094yÂhðk`\u009a«P\u0080\u0094Ë\u0088µEF\u0086Û¬Y¨Ļrõqi¼\u0089Wi°§\u0090\u0092Ð±´°^[\u0088À|ĠO@ÆxO\\t\u008ea\\tĕtû{ġ\u008cȧXýĪÓjùÎRb\u009b\u009a^Î\u009bf\u007fK[Ý\u008fděYfíÙTy\u008euUSyŌŏů@Oi½\u0092éŅ\u00adaVcř§ax¹XŻác\u0087\u009eWU£ôãºQ¨÷Ñws¥qEH\u0089Ù|\u0089\u009bšYQoŕÇyáĂ£MÃ°oť\u008fÊ\u0089P¡m\u008f\u009aWO¡\u0080v\u0086{ôvîēÜISpÌhp¨ \u0091j\u0086deŔQÖj\u0098\u007fX³à\u0099Ĉ[n`Yp\u007f@U\u009e\u0096cM`\u0092RKh\u008cEb\u009c\u0094pŞ\u007flNut®Etq\u0082nsÁ\u008agA\u009d\u008biú\u0081\u008boH\u0087qCX\u0087\u0094hfgu\u0093~Ï\u008bWP½¢G^}¯ÅīGC\u009f\u009dÑ^ãziMáļMTÃƘrMc|O_\u008f\u009e¯Ŏ´|\u0087morDkO\\mĆJfl@cĢ¬¢aĦtRıÒ\u0099¾ùƀ^juųœK\u00ad\u0083UFy\u0099\u0097Ɲ\u0085\u009bīÛ÷ąV×qƥV¿aȉd³\u009dB\u009bqPBm\u009baËđŻģm\u0093Å®V\u008a¹d^K\u0087Ko\u009fnYg\u0093¯Xhqa\u007f\u0094Ldu¥\u0095Ípǅ¡KąÅ\u0083kĝęěhq\u0087}HyÃ\u0093]¹ǧ£\u0085Í÷¿qáµ§\u009a\u0099g\u0091¤o^á¾ZE\u0087¤i`ĳ{n\u0095\u0083Ol\u008f»\u009fWÝĔįhg\u008d\u009bF[¿¡\u0097ßkOüš_\u0089\u0080ū\u008bi\u0084ǱàUtėGyl\u0083}\u008d\u008cÓM}\u0080jp\u007fEC~¡FtoQi\u0091\u009aHk\u009dk{\u0090Ãmï\u0082"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            119712,
                            40641
                        ]
                    ],
                    [
                        [
                            121616,
                            39981
                        ]
                    ],
                    [
                        [
                            116462,
                            37237
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    114.502461,
                    38.045474
                ],
                "name": "河北",
                "childNum": 3
            }
        },
        {
            "id": "140000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@ÞĩÒ\u0083S\u0089ra}Á\u0080yWix±Üe´lè\u0093ßÓǏok\u0091ćiµVZģ¡co\u009c\u0091TSË¹\u007fĪmnÕńe\u0096hZg{gtwªpXaĚThȑp{¶Eh\u0097®RćƑP¿£\u0091P\u009dmc¸mQ\u007fÝW\u0095ďȥoÅîɡųAďä³aÏ\u0089J\u0091½¥PG\u00adąSM\u00ad\u0099\u0085EÅruµé\u0080\u0091YÓ\u008e\u0095Ō_d\u009bĒCo\u00adÈµ]¯\u0090_²Õjā\u008eK~\u008f©ÅØ^Ô\u009bkïçămÏ\u0091k]\u00ad±\u0083cÝ¯ÑÃmQÍ~_a\u0097pm\u0085\u008d~ç¡q\u0093\u0088u{JÅŧ·\u009dLs}\u0096EyÁÆcI{¤\u007fIi\u008dCfUc\u0095ƌÃp§]ě\u009b«vD@\u007f¡SÀ\u0091µM\u0082Åwu\u008eYY\u0087¡DbÑc¡h\u0083×]nkoQdaMç~eD\u0095ÛtT\u0089©±@¥ù@É¡\u0089ZcW|WqOJmĩl«ħşvOÓ«Iq\u008dăV\u0097¥\u009fD[mI~Ó¢cehiÍ]Ɠ~ĥqX\u008a·eƷ\u009cn±\u0093}v\u0095[ěď\u008eŕ]_\u0091œ\u0095`\u0089¹\u0083§ÕōI\u0099o©b\u00ads\u007f^}\u007fÉt\u008d±ū«³p£ÿ·Wµ|¡¥ăFÏs×\u008c¥\u007fŅx\u009fÊdÒ{ºvĴÎêÌɊ²¶\u0080ü¨|ÞƸµȲ\u0091LLúÉƎ¤ϊęĔV`\u0084_bª\u008bS^|\u009fd\u008azY|dz¥p\u0086ZbÆ£¶ÒK}tĦÔņƠ\u0082PYzn\u0080ÍvX¶Ěn Ġ\u0081Ô\u0084zý¦ª\u0098÷\u009eÑĸÙ\u008eUȌ¸\u0082dòÜJð´\u0092ìúNM¬\u008cXZ´\u0091¤ŊǸ_tldI\u009a{¦ƀðĠȤ¥NehXn\u0081YG\u0082\u0087R° ƬDj¬¸|CĞ\u0084Kq\u0082ºfƐiĺ©ª~ĆOQª ¤@ìǦɌ²æB\u008cÊ\u0094T\u009cŸ\u0098ʂōĖ\u0092\u009aĴŞ\u0096Ȁ\u009cÆÿȄlŤĒö\u0084t\u0094Î½î¼ĨXh\u008c\u0091\u0098|ªM¤Ðz"
                ],
                "encodeOffsets": [
                    [
                        116874,
                        41716
                    ]
                ]
            },
            "properties": {
                "cp": [
                    111.849248,
                    36.857014
                ],
                "name": "山西",
                "childNum": 1
            }
        },
        {
            "id": "150000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@Č^â£Ăh\u0096\u009aĖMÈÄw\u0082\\fŦ°W ¢¾luŸD\u0084w\u008a\\̀ʉÌÛM\u0085Ā[bÓ\u009eEn}¶Vc\u0085ê\u0093s\u0083\u0096\u009b¯\u008dPq\u0083FB\u0085\u0089|S\u0095³C|kñ\u0095H\u008b\u008fd\u0091iÄ¥\u008ds\u0088ŉÅ\u0091\u0085PóÑÑE^\u0091ÅPpy_YtS\u0099\u008dhQ·aHwsOn\u007fŉÃ\u009as©iqj\u009b\u0089\u0080USiº]ïW\u009a\u0089«gW\u0081¡A\u0096\u0081Rëś\u009bĳĘ\u0095\u0085\u008c\u0081ů`çõh]y»ǃ\u009fǛҤxÒm~zf}pf|ÜroÈzrKÈĵSƧ\u0084ż؜Ġu¦ö"
                    ],
                    [
                        "@@sKC\u009a\u0085GS|úþX\u0094gp\u009b{ÁX¿\u009fć{ƱȏñZáĔyoÁhA\u008f\u0099}ŅĆfdŉ\u0084_¹\u0084Y°ėǩÑ¡H¯¶oMQqð¡Ë\u0099|\u0091Ñ`ƭŁX½·óÛ\u0093\u008dxğįÅcQ\u0087\u0088\u0093\u0083s«tȋǅF\u0093\u009f\u0081\u009dù^i\u008d\u0091t«Č¯[\u009bh\u0081\u0081Ai©á¥ÇĚ×l|¹y¯YȵƓ\u008bñ\u0090Ǚµï\u0082ċ\u0099Ļ|D\u009c\u0099üȭ¶¡\u0098\u009boŽäÕG\\Ä\u008fT¿Òõr¯\u009c\u009fLguÏYęRƩ\u009aɷŌO\\İÐ¢æ^Ŋ ĲȶȆbÜG\u008eĝ¬¿ĚVĎgª\u008d^íu½jÿĕęjık@Ľ\u0083]ėl¥Ë\u0087ĭûÁ\u0084\u0083ėéV©±ćn©\u00adȇ\u009eÍq¯½\u0095YÃÔŉ\u0093ÉNÑ\u009dÅÝy¹NqáʅDǡËñ\u00adƁYÅy̱os§ȋµʽǘǏƬɱà\u0091ưN¢ƔÊuľýľώȪƺɂļ\u009ex\u009cZĈ}ÌŉŪ\u0098ĺœ\u008eĭFЛĽ̅ȣͽÒŵìƩÇϋÿȮǡŏçƑůĕ~Ç\u008d\u009b¼ȳÐUf\u0086dIxÿ\\G \u008f\u0088zâɏÙOº·pqy£\u0086@\u0090\u008c\u008aqþ@Ǟ˽IBäƣzsÂZ\u0086ÁàĻdñ°ŕzéØűzșCìDȐĴĺf®\u008eÀľưø@ɜÖÞKĊŇƄ§\u0082͑těï͡VAġÑÑ»d³öǍÝXĉĕÖ{þĉu¸ËʅğU̎éhɹƆ̗̮ȘǊ֥ड़ࡰţાíϲäʮW¬®ҌeרūȠkɬɻ̼ãüfƠSצɩςåȈHϚÎKǳͲOðÏȆƘ¼CϚǚ࢚˼ФÔ\u0082¤ƌ\u009eĞ\u009d̪Qʤ´¼mȠJˀ\u009fƲÀɠmǐnǔĎȆÞǠN~\u0080ʢĜ\u0082¶ƌĆĘźʆȬ˪ĚĒ¸ĞGȖƴƀj`ĢçĶāàŃºēĢ\u0083Ėć\u009aY\u008cÀŎüôQÐÂŎŞǆŞêƖ\u009a\u0098oˆDĤÕºÑǘÛˤ³̀gń\u0081ƘĔÀ^\u009eªƂ`ªt¾äƚêĦĀ¼Ð\u0080Ĕǎ¨Ȕ»͠^ˮÊȦƤøxRrŜH¤¸ÂxDÄ\u009d\u008c|ø˂˜Ʈ\u0090Ð¬ɚwɲFjĔ²Äw°ǆdÀÉ\u009e_ĸdîàŎjÊ\u009cêTĞªŌ\u0087ŜWÈ|tqĢUB~´°ÎFC\u0095\u008eU¼pĀēƄN¦\u008d¾O¶\u008ałKĊOj\u0093Ě\u0094j´ĜYp\u0098{¦\u0084\u0088SĚÍ\\T\u009a×ªV\u0096÷Ší¨ÅDK°ßtŇĔ\u007fK\u009a¨ǵÂcḷ̌ĚǣȄĽF\u0087lġUĵ\u009cŇ\u008bȣFʉɁ\u0083MğįʏƶɷØŭOǽ«ƽ\u0090ū¹Ʊő̝Ȩ§ȞʘĖiɜɶʦ}¨֪ࠜ̀ƇǬ¹ǨE˦ĥªÔêF\u008exúQ\u0090\u0084Er´W\u0084rh¤Ɛ \\talĈDJ\u0098Ü|[Pll̚¸ƎGú´P\u009e¬W¦\u0086^¦\u0096H]prR\u0093n|\u0090or¾\u0090wLVnÇIujkmon£cX^\u008fBh`¥V\u0094\u0084¦U¤¸}\u0080xRj\u0096[^xN[~ª\u008axQ\u0084\u0082[`ªHÆÂExx^w\u009aN¶Ê\u0098|¨ì\u0086\u0098\u0080Mr\u009cdYp\u0082\u0090oRzNy\u0098ÀDs~\u0080bcfÌ`L\u0096¾n\u008b|¾T\u0082°c¨È¢a\u0082r¤\u0096`[|òDŞĔöxElÖdH\u0084ÀI`\u0084Ď\\Àì\u0081~Æ\u008eR¼tf\u0095¦^¢ķ¶e\u0094ÐÚM\u008cptgj\u0096\u0084ɡČÅyġLû\u0099ŇV\u007f®\u008aÄ\u008fÈƀ\u0086Ď°P|ªVV\u0086ªj\u0096¬ĚÒêp¬\u0096E|ŬÂc|ÀtƐK f\u0088{ĘFĒ\u009cƌXƲąo½Ę\u0091\\¥\u0096o}\u009bÛu£ç\u00adkX\u0091{uĩ«āíÓUŅßŢq\u0080\u008fŤ¥lyň[\u0080oi{¦\u008bL\u0087ń\u0087ðFȪȖ\u0094\u009dĒL\u0084¿Ì\u008b\u0088f\u008c£K£ʺ\u0099oqN\u009f\u0083wğc`ue\u0097tOj×°KJ±q\u0083Æġm\u0089Ěŗos¬\u0085qehqsu\u009c\u0083H{¸kH¡\u008a\u0085ÊRǪÇƌbȆ¢´äÜ\u008d¢NìÉʖ¦â©Ż؛Ç@Vu»A\u0097ylßí¹ĵê\u0085ÝlIS\u007fò³C¹Ì\u008fâ\u0084²i¶\u0092Ìoú^H\u0093²CǜңǄ z¼g^èöŰ_\u008b\u0082\u0096\u0086Ĳĕê\u0084\u009c}gÁnUI«m\u0089\u0085\u0084\u008b]j\u0087vV¼\u008deuhwqA\u0084\u008faW\u0098\u0083_µj\u0085»çjioQR¹ēÃßt@r³[ÛlćË^ÍÉáG\u0093\u009bOUÛ\u0097OB±\u0095\u007fX\u009fkÅ\u0087¹£k|e]ol\u0099\u009fkVÍ¼Õq\u007ftaÏõjgÁ£§U^\u008c\u0094RL\u0088ËnX°Ç\u0092Bz\u008d\u0086^~wfv\u0088ypV ¯\u0084ƫĉ˭ȫƗŷɿÿĿƑ˃ĝÿÃǃßËőó©ǐȍŒ\u009dĖM×ÍEyx\u008bþp]Évïè\u0091v\u009dƀnÂĴÖ@\u0082\u0089\u0086V~Ĉ\u0099\u008a³ME\u0088ĸÅĖt\u0097ējyÄDXÄxGQuv_\u009bi¦aBçw\u0091˛wD\u0099©{\u009ftāmQ\u0080{EJ\u008f§KPśƘƿ¥\u008d@\u0089sCT\u0095É}Ƀw\u0088Ƈy±\u009fg\u0090Ñ\u0093}T[÷k\u007fÐç¦«\u0085SÒ¥¸ëBX½\u0089HáÅµÀğtS\u0090ÝÂa[ƣ°¯\u0081¦\u0081Pï¡\u0081]£ġ\u0093\u0096\u0093Òk®G²\u0084èQ°óMq}E\u008aóƐÇ\\\u0081\u0083\u0087@áügQÍ\u008bu¥F\u0083\u0093TÕ\u009b¿Jû\u0087]|mvāÎYua\u0081^WoÀa·\u00adząÒot×¶CLƗi¯¤mƎHǊ¤îìɾŊìTdåwsR\u008dÖgĒųú\u0081ÍġäÕ}Q¶\u0097\u0088¿A\u0095\u0086\u008b[¡\u008c{d×uQA\u0083\u009bM\u0095xV\u008bvMOmăl«ct\u007f[wº_\u009aÇÊ\u008a\u008e\u009fjbÂ£ĦS_é\u0093QZ\u0093\u007f_lwgOiý\u007fe`Y\u007fYLq§IÁ\u0088ǳ£ÙË[ÕªuƏ³ÍT\u0097s·b\u0081ÁĽäė[\u009bb[\u0088ŗfãcn¥îC¿÷µ[ŏÀQ\u00adō\u009aĉm¿Á^£mJVm\u0087\u0097\u008fL[{Ï_\u009d£\u009bF¥Ö\u008d{ŹA}\u0085×Wu©ÅaųĳƳhB{·TQqÙIķË\u0091Zđ©Yc|M¡\u0085L\u0095\u009deVUóK_\u009d\u009dQWk\u0092_ĥ\u0091¿ãZ\u008f\u0095\u0081»X\\ĴuU\u0083è\u0087lG®ěłTĠğDŃ\u0094OrÍd\u0082ÆÍz]\u008b±\u0085ŭ©\u009fÅ\u0092]\u008cÅÐ}UË¥©Tċ\u0099ïxgckfWgi\\ÏĒ¥HkµE\u0098ë{»ÏetcG±ahUiñiWsɁ\u0088·c\u009d\u0096C\u0082Õk]wȑ|ća}w\u0085VaĚá \u009e\u008cG°ùnM¬¯\u0086{È\u0088ÐÆA\u0092¥ÄêJxÙ¢\u0094hP¢Û\u0088º\u0080µ\u0090wWO\u009fóF\u008e\u009aÁz^ÀŗÎú´§¢T¤ǻƺS\u0090ė\u0089ǵhÝÅQgvBHou\u0081ʝl_o¿Ga{ïq{¥|ſĿHĂ÷aĝÇq\u0087Z\u008f\u0091ñiñC³ª\u0097\u0085»E`¨åXēÕqÉû[l\u0095}\u0081ç@čƘóO¿¡\u0083FUs\u008dA\u0089\u0093ʽīcc\u009aoc\u0083\u0082\u0083ÇS}\u0084\u0093£\u0087IS~ăl\u008fkĩXçm\u0090Ĉ\u0085ŀÐ\u0082oÐdx\u007fÒuL^T{r@¢\u0091\u009eÍ\u0083ĝKén£kQ\u0099\u0089y\u009aÅõ\u007fËXŷƏL§~}kq\u009a»\u0081IHėǅjĝ\u009f»ÑÞo\u009få°qT\u009dt|r\u008d\u007f©ÏS\u008b¯·eŨĕx«È[eM\u0088¿yu\u0088\u0091pN~¹ÏyN£{©\u0092\u0097g\u008bħWí»Í¾s\u0093əšǅ_ÃĀɗ±ą\u007f\u0099ĳĉ\u008fʍŌŷ\u0097S\u009bÉ\u0093A\u008b±åǥɋ@ë\u009f£R©ąP©}ĹªƏj¹er\u0081\u0083LDĝ·{i«ƫC£µ"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            127444,
                            52594
                        ]
                    ],
                    [
                        [
                            113793,
                            40312
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    111.670801,
                    41.818311
                ],
                "name": "内蒙古",
                "childNum": 2
            }
        },
        {
            "id": "210000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@L\u0096\u008e@@s\u0099a"
                    ],
                    [
                        "@@MnNm"
                    ],
                    [
                        "@@\u0081d\u0082c"
                    ],
                    [
                        "@@eÀ\u0082C@b\u0082\u0093\u009d\u0089"
                    ],
                    [
                        "@@f\u0087\u0085Xw\u007fkbr\u0096Ä`qg"
                    ],
                    [
                        "@@^jtW\u0091Q"
                    ],
                    [
                        "@@\u0081~ Y]c"
                    ],
                    [
                        "@@G`ĔN^_¿\u0081Z\u0082ÃM"
                    ],
                    [
                        "@@iX¶B\u008bY"
                    ],
                    [
                        "@@\u0084Y\u0083Z"
                    ],
                    [
                        "@@L_{Epf"
                    ],
                    [
                        "@@^WqCT\\"
                    ],
                    [
                        "@@\\[\u0093\u008b§t|\u0094¤_"
                    ],
                    [
                        "@@m`n_"
                    ],
                    [
                        "@@Ïxǌ{q_×^Giip"
                    ],
                    [
                        "@@@\u009cé^B\u0086\u0087nt\u0088aÊ\u007fU\u0097\u0098\u009f]x ¯ÄPĲ\u00ad°h\u0080ʙK³\u0086V\u0088Õ@Y~\u0086|EvĹsÇ\u0084\u008d¦\u00adL^pÃ\u0082²ŸÒG \u0092Ël]\u0084xxÄ_\u0098fT¤Ď¤c\u008e\u009cP\u0084\u0096C¨¸TVjbgH²sdÎdH\u0090t`B\u0088\u0097²¬GJję¶[ÐhjeXdlwh\u009aðSČ¦ªVÊÏ\u0080\u008bÆ\u0091Z\u0098ÆŶ®²\u0086^\u008cÎy\u0081ÅÎcPqń\u0093ĚDMħĜŁH\u00ad\u0088k\u0084çvV[ĳ¼W\u0096\u0082Y\u0090ÀäĦ\u0092\u0091`Xl\u009eR`\u009eôLUV\u009efK\u0096¢\u0086{NZdĒª\u0092YĸÌÚJRr¸SA|ƴgŴĴÆbvªØX~\u0086źB\u008e|¦Õ\u009cE\u009e¤Ð`\\|\u0090K\u0088\u0098UnnI]¤ÀÂĊnŎ\u0099R®Ő¿¶\\ÀøíDm¦ÎbŨab\u0089\u009caĘ\\ľã\u0082Â¸a\u0098tÎSƐ´©v\\ÖÚÌǴ¤Â\u0087¨JKr\u0080Z_Z\u0080fjþhPkx\u0080`Y\u0094\u0092RI\u008cjJcVf~sCN¤ \u0088E\u0082\u009chæ\u008fm\u0089\u0096sHy¨SðÑÌ\\\\\u009fĐRZk°IS§fqŒßýáĞ\u008dÙÉÖ[^¯ǤŲ\u0084ê´\\¦¬ĆPM¯£\u009f\u0088»uïpùzEx\u0080\u009eanµyoluqe¦W^£ÊL}ñrkqWňûP\u0099\u0089UP¡ôJ\u008aoo·\u008cU}£\u008c\u0084[·¨@X\u008cĸ\u009f\u0093\u008b\u008bDXm\u00adÛÝ\u008fº\u0087\u009bGU\u008bCÁª½{íĂ^\u0090cj\u0087k\u0093¶Ã[q¤\u0093LÉö³cux«zZf\u0083²BWÇ®Yß½ve±ÃC\u0095ý£W{Ú^\u0092q^sÑ·¨\u008bÍO\u0081t\u0093¹·C\u0081¥\u0087GD\u008f\u009brí@w\u008dÕKţÃ\u009d\u008b\u0098\u009f«V·i}xËÍ÷\u0091i©ĝ\u0087ɝǡ]\u0083\u0088{c\u0099±OW\u008b³Ya±\u009f\u0089_ç©\u0082H\u009eĕoƫ\u0080Ňq\u0083r\u009d³\u0089Lys[\u0084ñ³¯OS\u0096ďOMisZ\u0086±ÅFC\u007f¥Pq{\u008f\u0082Ã[Pg}\\\u0097¿ghćO\u0085\u0095k^ģÁ\u008dFıĉĥM\u00adoEqqZûěŉ³F\u0091¦oĵ\u0097h\u009fÕP{\u008f¯~T\u009dÍlª\u0089N\u0089ßY\u0093Ð{Ps{ÃVU\u0099\u0099eĎwk±ŉVÓ½ŽJã\u0081ÇÇ»Jm°dhcÀff\u0091dF~\u0088\u0080ĀeĖ\u0080d`sx² \u009a\u0083®EżĀdQ\u008d\u008bÂd^~ăÔH\u0088¦\\\u009bLKpĄVez¤NP ǹÓ\u0097R\u0099ÆąJSh\u00ada[¦´Âghwm\u007f\u0080B\u0090Ð¨źhI|\u009eVV\u008e\u0097\u008e|p] Â¼èNä¶ÜBÖ¼\u0093L`\u0082¼bØæ\u008cKV\u0094\u009fpo\u009cúNZÞÒKxpw|ÊEMnzEQ\u009a\u008eIZ\u0094\u008eZ\u0087NB\u0088čÚFÜçmĩ\u0082WĪñt\u0091ÞĵÇñZ«uD\u0082±|Əlĳ¥ãn·±PmÍa\u0089\u0096d\u008fa\u0087 CL\u0087Ǒ\u007fkùó¡³Ï«QaċÏ\u0091OÃ¥ÕđQȥċƭy\u008b³ÃA"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            123686,
                            41445
                        ]
                    ],
                    [
                        [
                            126019,
                            40435
                        ]
                    ],
                    [
                        [
                            124393,
                            40128
                        ]
                    ],
                    [
                        [
                            126117,
                            39963
                        ]
                    ],
                    [
                        [
                            125322,
                            40140
                        ]
                    ],
                    [
                        [
                            126686,
                            40700
                        ]
                    ],
                    [
                        [
                            126041,
                            40374
                        ]
                    ],
                    [
                        [
                            125584,
                            40168
                        ]
                    ],
                    [
                        [
                            125453,
                            40165
                        ]
                    ],
                    [
                        [
                            125362,
                            40214
                        ]
                    ],
                    [
                        [
                            125280,
                            40291
                        ]
                    ],
                    [
                        [
                            125774,
                            39997
                        ]
                    ],
                    [
                        [
                            125976,
                            40496
                        ]
                    ],
                    [
                        [
                            125822,
                            39993
                        ]
                    ],
                    [
                        [
                            125509,
                            40217
                        ]
                    ],
                    [
                        [
                            122731,
                            40949
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    123.429096,
                    41.796767
                ],
                "name": "辽宁",
                "childNum": 16
            }
        },
        {
            "id": "220000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u0091pä\u0094³PCl\u0083FbbÍz\u009a\u0080wBG\u0092ĭ\u0080Z\u0084Åi\u0093»\u0083lY\u00adċ²Sg\u008ekÇ£\u0097^S\u0089\u0093qd¯\u0095\u008bR\u0085©é\u008e£¯S\u0086\\cZ¹iűƏCuƍÓX\u007f\u0087oR}\u0093M^o\u0095£\u0085R}oªU\u00adF\u0085uuXHl\u008fEÅ\u0095\u0087\u0080Ï\u007f©¤ÛmT\u008eþ¤D\u0096²ÄufàÀ\u00adXXÈ±Ae\u0084yYw¬dvõ´KÊ£\u0094\\rµÄl\u0094i\u0088\u008fdā]|î©¾DÂV\u008c\u009cH¹\u0088Þ\u0090®ÜWn\u008cC\u0094\u008cķ W\u008b§@\\¸\u008b\u0083~¤\u008bVp¸\u0089póIO¢\u008aVO\u009aŇürXql~òÉK]¤¥Xrfkvzpm¶\u009dbw\u007fyFoúvð\u0087¼¤ N°ąO¥«³[\u0083éǡű_°Õ\\ÚÊĝ\u008eþâőàerR¨\u00adJYlďQ[ ÏYëÐ§TGz\u0095tn\u008aß\u0090¡gF\u0081\u008fkM\u009fāGÁ¤ia\u008d É\u0089\u0099È¹`\\xs\u0080¬dĆkNnuNU\u008a\u0096u\u009eP@\u0082vRY¾\u0095\u0096\\¢\u0085\u008cGªóĄ~RãÖÎĢù\u0082đŴÕhQ\u008extcæëSɽŉíëǉ£ƍG£nj°KƘµDsØÑpyĆ¸®¿bXp\u0082]vbÍZuĂ{n\u0088^Iü\u009cÀSÖ\u0084\u0094¦E\u008cvRÎûh@â\u0084\u0088[\u0082ƏÈ\u0089ô~FNr¯ôçR±\u0083\u00adHÑl\u0095\u0092Ģ\u0096^¤¢\u0082Oð\u009f\u008cævxsŒ]ÞÁT\u008fĠs¶¿âÆ\u008aGW¾ìA¦·TÑ¬\u0086è¥\u0080ÏÐJ¨¼\u008fÒÖ¼\u0083ƦɄxÊ~S\u0096tD@\u008aĂ¼Ŵ¡jlºW\u009evÐ\u0089\u0088zƦZÐ\u008e²CH\u0097 \u0084A\u009dxiukd\u008b\u008cGgetqmc\u009eÛ£Ozy¥cE}|\u0085¾cZ\u0085\u008dk\u0082\u0089¿uŐã[oxGikfeäT@\u0085\u009aSUwpiÚFM©\u0092£è^Ú\u009f\u0082`@v¶eň\u0086f\u0081 h\u0098eP¶\u0090\u009et\u0093äOlÃ\u0094Ug\u0083ÞzŸU`l\u009c}ÔÆUvØ_Ō¬Öi^ĉi§²Ã\u008aB~¡Ĉ\u0099ÚEgc|DC_Ȧm²rBx¼MÔ¦ŮdĨÃâYx\u0091ƘDVÇĺĿg\u008d¿cwÅ\\¹\u0098¥Yĭl\u0081\u009c¤\u009eOv\u0086\u009aLjM_a W`zļMž·\\swqÝSA\u0087\u009a\u0097q\u0089Śĳ\u007f¯\u008a\u0091°k\u0090\u008aRē°wx^ĐkǂÒ\u0093\u0084\u009c\u009e\u0093\u009c\u008e\u0084\u008b\\]\u0098nrĂ}²ĊŲÒøãh·M{yMzysěn\u009dĒġV·°\u0093G³¼XÀ\u0093\u0093\u0099¤¹\u008di´o¤Ń\u009a\u009fÈ`Ì\u0083ǲÄUĞd\\iÖ\u009a\u008c\u0088mÈBĤÜɲDEh LG¾ƀÄ¾{Wa\u008c\u008dYÍÈ\u008fĢĘÔRîĐj\u008b}Ç\u009e\u0093ccj\u0087oUb½\u009a\u008d{\u0093h§Ǿ{K\u008bƖµÎ÷\u009eGĀÖŠåưÎs\u00adl\u009b\u0095yiē«\u008b`å§\u009dH\u007f¥Ae\u009d^§\u0084GK\u0081}iã\\c]v©ģZ\u0093mÃ|\u0093[M}ģTɟĵÂ\u0091Â`À\u007f\u0096çm\u0089\u0091FK¥ÚíÁbX\u009a³ÌQÒ\u0091Ho\u0081f{\u0089]e\u0080pt·GŋĜYünĎųVY^\u0092\u0098ydõkÅZW\u0084«WUa~U·Sb\u0095wGçǑ\u0082\u0093iW^q\u008bF\u0082\u0093\u009buNĝ\u008d\u0097·Ew\u0084\u008bUtW·Ýďæ©PuqEzwAV\u0095\u0097XR\u0089ãQ`\u00ad©G\u008cM\u0087ehc\u009bc\u0094\u009dďÏ\u009dd\u0087©ÑW_Ï\u0097Yƅ\u008c»\u0085é\\\u008d\u0083ɹ~ǙG³mØ©Bš\u0090uT§Ĥ½¢Ã_Ã½\u0091L¡\u008d\u0091ý\u009fqT^rme\u0099\\Pp\u0095ZZb\u0083y\u009f\u0092uy\u0081bQ\u0097efµ]UhĿDCmûva\u009aÙNSk\u009dCwn\u0089cćfv~\u0085Y\u008b\u0084ÇG"
                ],
                "encodeOffsets": [
                    [
                        130196,
                        42528
                    ]
                ]
            },
            "properties": {
                "cp": [
                    125.3245,
                    43.886841
                ],
                "name": "吉林",
                "childNum": 1
            }
        },
        {
            "id": "230000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@ƨ\u0083ĶTLÇyqpÇÛqe{~oyen}s\u0089`q\u0087i\u008dXG\u0094ù]Ëp½\u0093©lÉ\u0087Áp]Þñ´FĂ\u0094^f\u0091ä\u008fîºkà\u0098z¼BUvÈ@"
                    ],
                    [
                        "@@U\u0083µNÿ¥īèç\u0081\u008b\u0095\u009dHÍøƕ¶L\u008cǽ|g¨|\u0094\u0099\u008ea¾pVi\u0088dd\u009d\u0094~Èi\u008cíďÓQġėÇ\u0090ZÎ\u008b\u008eXb½|ſÃH½\u009fKFgɱCģÛÇA\u0087n\u0099\u008bjÕc[VĝǱÃË\u0084Ç_\u0099 £ń³p\u008ej£º\u0094\u009a¿\u0094»WH´¯\u0094U¸đĢm\u009etĜyzzNN|g¸÷äűÑ±ĉā~mq^\u0097\u008c[\u008d\u0083\u0094\u009b\u009b\u009d\u0094\u0083ǁÑďlw]¯xQĔ\u008f\u0089¯l\u0089\u0092\u0080°řĴr\u008a\u0099\u0098B\u0088ÞTxr[tŽ¸ĻN_y\u009fX`biN\u0099Ku\u0085\u009dP\u009b£k\u0082ZĮ\u0097¦[ºxÆÀdh\u008eĹŀUÈƗCw\u0092áZħÄŭcÓ¥»NAw±qȥnD`{ChdÙFć\u009a}¢\u0089A±Äj¨]ĊÕjŋ«×`VuÓÅ\u009b~_kŷVÝyh\u0084\u0093VkÄãPs\u0094\u008f\u009dOµ\u0097f\u009fge\u0082Ň\u0085µf@u\u0081_Ù Ùc\u009fªNªÙEojVx\u0099T@\u0086ãSefjlwH\\pŏäÀv\u0081\u008a\u008elY\u0086½d{\u0086F~¦dyz¤P\u009dÜndsrhf\u008bHc\u008cvlwjF\u009c£\u0081G\u0098±DÏ\u008dƥY\u0087yÏ\u008a\u009du¹XikĿ¦ÏqƗǀOŜ¨LI\u0090|FR\u007fĂn sª|C\u009a˜zx\u0090Aè¥b\u009cfudTr\u007fFWÁ¹Am|\u0098ĔĕsķÆF\u0087´N\u009a\u0089}ć\u0085U\u0081\u008aÕ@Áĳſmu\u009eç\u0092uð^Êýow\u008cFzØÎĕNő\u009eǏȎôªÌŒǄàĀÄ˄ĞŀƒʀĀƘŸˮȬƬĊ°\u0083U\u009fzou\u0087xe]}\u008e\u0085AyÈ\u0091W¯ÌmK\u0087\u0093Q]\u008bĪºif¸ÄX|sZt|½ÚUÎ lk\u009a^p{f¤l\u0088ºlÆW \u0096\u0080A²\u0098PVÜ\u009cPH\u0094Êâ]ÎĈÌÜk´\\@qàsĔÄQºpRij¼èi\u0086`¶\u0097\u0084bX\u0083\u0090rBgxfv»\u008euUi\u0088\u008c^v\u008d~\u0094J¬mVp´£\u008c´VWrnP½ì¢BX\u0082¬h\u0099\u008aðX¹^Tj\u007fV\u009c\u008ariªj\u0099tŊÄm\u0080tPGx¸bgR\u009a\u008esT`ZozÆO]\u0092ÒFôÒ\u0086OÆ\u0092\u0087Ŋ\u008cvÅ\u009e\u0094p\u0092cG\u008cê\u008asx´DR\u0096\u008c{A\u0086\u0084EOr°\u008c\u0095\u009ex|í\u009cb\u0088³Wm~\u009dDVj\u008dºéNN\u0086ËÜ˛ɶ\u00adG\u0083xŷCSt\u009f}]ûō\u0095SmtuÇÃĕN\u0095\u0099āg»\u009aíT«u}ç½BĵÞʣ¥ëÊ¡MÛ\u008e³ãȅ¡ƋaǩÈÉQ\u0089\u0086G¢·lG|\u009b\u0084tvgrrf«\u0086ptęŘn\u008aÅĢr\u0084I²¯LiØsPf\u0098_vĠd\u0084xM prʹ\u009aL¤\u008b¤\u0087eË\u008c\u0083ÀđK\u0093\u009eïÙVY§]I\u0087óáĥ]ķ\u0086K\u0088¥\u008cj|\u007fpŇ\\kzţ¦\u007f\u0090šnņäÔVĂîĪ¬|vW\u0092®l¤èØr\u0082\u0098\u0095xm¶ă~lÄƯĄ̈́öȄEÔ¤ØQĄ\u0096Ą»ƢjȦOǺ¨ìSŖÆƬy\u0094\u008dQ\u009cv`\u0096cw\u0083ZSÌ®ü±Ǆ]ŀç¬B¬©ńzƺŷɄe\u0090eO\u0081ĨS\u0092\u009d\u008cfm Ċ\u0082ƀP̎ēz©Ċ\u0082ÄÕÊmg\u009fÇsJ¥Ɣ\u0088Ŋśæ\u0092Î\u0081Ñqv¿íUOµª\u0089ÂnĦÁ_½ä@êí\u0085£P}Ġ[@gġ}g\u0093Ɋ×\u0093ûÏWXá¢užƻÌsNÍ½\u009dƎÁ§čŐ\u009bA\u008fēeL³àydl\u009b¦ĘVçŁpśǆĽĺſÊ\u0083QíÜçÛġÔ\u008fsĕ¬\u0097Ǹ¯YßċġHµ ¡eå`\u009dļ\u0083rĉŘóƢFì\u0093ĎWøxÊk\u0086\u0094ƈdƬ\u008fv|\u0096I|\u007f·©NqńRŀ\u0083¤é\u0094eŊ\u009cŀ\u009b\u0088àŀU²ŕƀB\u0082\u007fQ£Ď}L¹Îk@©ĈuǰųǨ\u0094Ú§ƈnT\u007fËÇéƟÊcfčŤ^Xm\u0087\u0097H\u008dĊĕË«W·ċëx³ǔķÐċJā\u0082wİ_ĸ\u0098Ȁ^ôWr\u00ad°oú¬Ħ\u0085ŨK~\u0094ȰCĐ´Ƕ£\u0092fNÎèâw¢XnŮeÂÆĶ\u008e\u0090¾¾xäLĴ\u0081ĘlļO¤ÒĨA¢Êɚ¨®\u0082ØCÔ ŬGƠ\u0094ƦYĜ\u0087ĘÜƬDJ\u0097g_ͥœ@čŅĻA\u0093¶¯@wÎqC½Ĉ»N\u009făëK\u0099ďÍQ\u0093Ù\u007fƫ[«Ãí\u0095gßÔÇOÝáW\u0091ñ\u008fuZ\u0093¯ĥ\u0080\u009f\u008dŕā¡ÑķJu¤E \u009få¯°WKÉ±_d_}}\u008dvy\u009fõu¬ï¹ÓU±½@gÏ¿rÃ½D\u0089\u0086g\u0085Cd\u0089µ\u0097°MF\u0081\u008fYxw¿CG£\u008bRƛ½\u007fÕ{]L§{qqą\u009a¿BÇƻğë\u009aܭǊË|c²}Fµ}\u009bÙRsÓp\u008fg\u007f±\u008aQNqǫŋRwŕnéÑÉK\u009f\u0086«SeYR\u0085ŋ\u008b@{¤SJ}\u009aD Ûǖ֍\u009f]g\u009dr¡µŷjqWÛham³~S«\u0093\u0084\u009bÞ]"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            127123,
                            51780
                        ]
                    ],
                    [
                        [
                            134456,
                            44547
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    128.642464,
                    46.756967
                ],
                "name": "黑龙江",
                "childNum": 2
            }
        },
        {
            "id": "320000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@cþÅPi\u008a`Z\u009fRu¥É\\]~°\u008eY`µ\u0086Ó\u007f\u0083^phÁbnÀşú\u008eòa\u0096ĬºTÖŒb\u0082\u0098e¦¦\u0080{¸ZâćNp\u008c©\u009eHr|^\u0088mjh\u008aSEb\\afv`sz^lk\u008elj\u008bÄtg\u008b¤D\u0098\u00ad¾X\u009a¿À\u0092|Đ\u0094iZ\u0084\u009dȀåB·î}GL¢õcßja\u009fyBFµÏC^ĭ\u0095cÙt¿sğH]j{s©HM¢\u0083Q\u007fnDÀ©DaÜÞ\u008c·jgàiDbPufjDk`dPOî\u0083hw¡ĥ\u0087¥\u009aG\u0098\u009fP²ĐobºrY\u0086\u0084î¶aHŢ´ ]´\u0082rıl\u009dw³r_{£DB_Ûdåuk|\u0088Ũ¯F\u007f Cºyr{XFy\u0099e³Þċ\u0087¿Â\u0099kĭB¿\u0084MvÛpm`rÚã\u0094@Ę¹hågËÖƿxnlč¶Åì½Ot¾\u007fdJl\u008aVJĂ\u008a\u009cǀ\u009cŞqvnO\u008a^\u009fJ\u0094Z\u0091ż·Q}êÍ\u008eÅmµÒ]\u008eƍ¦Dq}¬R^èĂ´ŀĻĊIÔ\u0092t\u009eĲyQŐĠMNt\u009cR®\u007fòLh\u008f\u0089\u009bĚs©»\u009c}OÓ\u008cGZz¶A\\jĨF\u0088äOĤ\u0098HY\u009a\u0086Jv\u0090ÞHNiÜaĎ\u009aÉ\u0096nFQl\u009aNM¤\u0088B´ĄNöɂtp\u0096Ŭdfå\u0085\u0088\u008bqm¿Qû\u008aùŞ\u0087Úb¤uŃJŴu»¹Ą\u0095l\u0081ȖħŴw̌ŵ²ǹǠ͛hĭłƕrçü±Y\u0099xci\u0087tğ®\u009djű¢KOķ\u0095Coy`å®VTa\u00ad_Ā]ŐÝɞï²ʯÊ^]afYǸÃĆēĪȣJđ͍ôƋÄ\u009dÄÍ\u008eī\u0089çÛɈǥ£\u00adÛmY`ó£Z\u008d«§°Ó³QafusNıǅ_k}¢m[ÝóDµ\u0097¡RLčiXy\u0087ÅNïă¡¸iĔÏ\u0091NÌŕoēdōîåŤûHcs}~Ûw\u007fbù¹£¦ÓC\u0081t\u008bOPr\u0083E^Òo\u008ag\u0099ĉIµ\u009eÛÅʹK\u0085¤½phM\u008aü`oæ\u0080\u0086ŀ"
                ],
                "encodeOffsets": [
                    [
                        121740,
                        32276
                    ]
                ]
            },
            "properties": {
                "cp": [
                    119.767413,
                    33.041544
                ],
                "name": "江苏",
                "childNum": 1
            }
        },
        {
            "id": "330000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@E^dQ]K"
                    ],
                    [
                        "@@\u0081jX^j\u0087"
                    ],
                    [
                        "@@sf\u008abU\u0087"
                    ],
                    [
                        "@@qP\\xz[ck"
                    ],
                    [
                        "@@\u0091R\u0083¢\u0082FX}°[s_"
                    ],
                    [
                        "@@Cb\u009c\\\u0097}"
                    ],
                    [
                        "@@e|v\\la{u"
                    ],
                    [
                        "@@v~u}"
                    ],
                    [
                        "@@QxÂF¯}"
                    ],
                    [
                        "@@¹n\u008cvÞs¯o"
                    ],
                    [
                        "@@rSkUEj"
                    ],
                    [
                        "@@bi\u00adZ\u008cP"
                    ],
                    [
                        "@@p[}INf"
                    ],
                    [
                        "@@À\u007f¿\u0080"
                    ],
                    [
                        "@@¹dnb\u008c\u0085"
                    ],
                    [
                        "@@rS\u009fBnR"
                    ],
                    [
                        "@@g~h}"
                    ],
                    [
                        "@@FlEk"
                    ],
                    [
                        "@@OdPc"
                    ],
                    [
                        "@@v[u\\"
                    ],
                    [
                        "@@FjâL~wyoo~\u009bsµL\u0096\\"
                    ],
                    [
                        "@@¬e¹aN\u0088"
                    ],
                    [
                        "@@\\nÔ¡q]L³ë\\ÿ®\u008cQÖ\u008e"
                    ],
                    [
                        "@@ÊA\u00ad©[¬"
                    ],
                    [
                        "@@Kx\u008cv\u007f\u00ad"
                    ],
                    [
                        "@@@hlIk]"
                    ],
                    [
                        "@@pW{\u008do||j"
                    ],
                    [
                        "@@Md|_mC"
                    ],
                    [
                        "@@¢\u0085X£Ï\u008dylD¼X\u0088tH"
                    ],
                    [
                        "@@hlÜ[LykAvy\u008f\u0081fw\u008d^E\u009e\u009b¤"
                    ],
                    [
                        "@@fp¤Mus\u0093R"
                    ],
                    [
                        "@@®_ma~\u008f\u0095LÁ¬\u009aZ"
                    ],
                    [
                        "@@i\u009dM\u0084xZ"
                    ],
                    [
                        "@@ZcYd"
                    ],
                    [
                        "@@Z~dOSo|A¿qZv"
                    ],
                    [
                        "@@@`\u0094EN\u008f¡v"
                    ],
                    [
                        "@@|\u0096TY\u008f{"
                    ],
                    [
                        "@@@n@m"
                    ],
                    [
                        "@@XWkCT\\"
                    ],
                    [
                        "@@ºw\u009aZRkĕWO¢"
                    ],
                    [
                        "@@\u0099X\u007f®±GrÆª\\ÔáXq{\u008b"
                    ],
                    [
                        "@@ůTG°ĄLHm°UC\u008b"
                    ],
                    [
                        "@@¤\u008e\u0080aÜx~}dtüGæţŎíĔcŖpMËÐ\u0092jē¢·ðĄÆMz\u0088jWKĎ¢Q¶\u0098À_ê\u0092\u0094_Bı\u0080i\u007f«pZ\u0080gf\u0080¤Nrq]§ĂN®«H±\u0087yƳí¾×ŸīàLłčŴǝĂíÀBŖÕª\u0088\u008aÁŖHŗŉåqûõ\u0090i¨hÜ·\u0083ñt»¹ýv_[«¸m\u0089YL¯\u0089Qª\u0085mĉÅdM\u0088\u0095gÇjcº«\u0095ę\u009c¬\u00adK\u00ad´\u0083B«Âącoċ\\xKd¡gěŧ«®á\u0092[~ıxu·Å\u0094KsËÉ\u008fc¢Ù\\ĭƛëbf¹\u009d\u00adģS\u0083Ĝ\u009dkáƉÔ\u00adĈZB{\u008aaM\u0091µ\u0089fzŉfåÂŧįƋǝÊĕ\u0081ġć£g³ne\u00adą»@\u00ad¦S®\u0082\\ßðC\u009a\u007fh\u0099iqªĭiAu\u0087A\u009d\u00adµ\u0094\u008d_W¥ƣO\\lċĢttC¨£t`\u0088\u0099PZäuXßB\u008ds\u0087Ļyek\u0080\u009dOđġĵHuXB\u009aµ]×\u008c\u0087\u00ad\u00ad\\\u009b°®¬F¢\u008f¾p\u0090µ¼kŘó¬Wät\u0092¸|@\u009e\u0095L¨¸µr\u0093ºù³Ù~§WI\u008b\u009fZW\u008e®\u0092±Ð¨ÒÉx\u0080`\u0089²pĜ\u0095rOògtÁZ}þÙ]\u0084\u0092¡\u008c\u009fFK\u0082wsPlU[}¦Rv\u008dn`hq¬\\\u0094\u0090nQ´ĘRWb\u0094\u0082_ rtČFIÖ\u008ak\u008a\u008aĦPJ¶ÖÀÖJĈĄTĚò\u009eC ²@Pú\u0085Øz\u009c©Pî¢£\u009cCÈÚ\u009cĒ±\u0084hŖ\u0087l¬â~nm¨f©\u0096iļ«m\u0087nt\u0096u\u0086ÖZÜÄj\u0093\u008aL\u008e®EÌ\u009cFª²iÊxØ¨\u009eIÈhhst"
                    ],
                    [
                        "@@o\\V\u0092zRZ}y\u0081"
                    ],
                    [
                        "@@\u0086@°¡mÛ\u009bGĕ¨§Ianá[ýƤjfæ\u0087ØL\u0096\u0095äGr\u0099"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            125592,
                            31553
                        ]
                    ],
                    [
                        [
                            125785,
                            31436
                        ]
                    ],
                    [
                        [
                            125729,
                            31431
                        ]
                    ],
                    [
                        [
                            125513,
                            31380
                        ]
                    ],
                    [
                        [
                            125223,
                            30438
                        ]
                    ],
                    [
                        [
                            125115,
                            30114
                        ]
                    ],
                    [
                        [
                            124815,
                            29155
                        ]
                    ],
                    [
                        [
                            124419,
                            28746
                        ]
                    ],
                    [
                        [
                            124095,
                            28635
                        ]
                    ],
                    [
                        [
                            124005,
                            28609
                        ]
                    ],
                    [
                        [
                            125000,
                            30713
                        ]
                    ],
                    [
                        [
                            125111,
                            30698
                        ]
                    ],
                    [
                        [
                            125078,
                            30682
                        ]
                    ],
                    [
                        [
                            125150,
                            30684
                        ]
                    ],
                    [
                        [
                            124014,
                            28103
                        ]
                    ],
                    [
                        [
                            125008,
                            31331
                        ]
                    ],
                    [
                        [
                            125411,
                            31468
                        ]
                    ],
                    [
                        [
                            125329,
                            31479
                        ]
                    ],
                    [
                        [
                            125626,
                            30916
                        ]
                    ],
                    [
                        [
                            125417,
                            30956
                        ]
                    ],
                    [
                        [
                            125254,
                            30976
                        ]
                    ],
                    [
                        [
                            125199,
                            30997
                        ]
                    ],
                    [
                        [
                            125095,
                            31058
                        ]
                    ],
                    [
                        [
                            125083,
                            30915
                        ]
                    ],
                    [
                        [
                            124885,
                            31015
                        ]
                    ],
                    [
                        [
                            125218,
                            30798
                        ]
                    ],
                    [
                        [
                            124867,
                            30838
                        ]
                    ],
                    [
                        [
                            124755,
                            30788
                        ]
                    ],
                    [
                        [
                            124802,
                            30809
                        ]
                    ],
                    [
                        [
                            125267,
                            30657
                        ]
                    ],
                    [
                        [
                            125218,
                            30578
                        ]
                    ],
                    [
                        [
                            125200,
                            30562
                        ]
                    ],
                    [
                        [
                            124968,
                            30474
                        ]
                    ],
                    [
                        [
                            125167,
                            30396
                        ]
                    ],
                    [
                        [
                            124955,
                            29879
                        ]
                    ],
                    [
                        [
                            124714,
                            29781
                        ]
                    ],
                    [
                        [
                            124762,
                            29462
                        ]
                    ],
                    [
                        [
                            124325,
                            28754
                        ]
                    ],
                    [
                        [
                            123990,
                            28459
                        ]
                    ],
                    [
                        [
                            125366,
                            31477
                        ]
                    ],
                    [
                        [
                            125115,
                            30363
                        ]
                    ],
                    [
                        [
                            125369,
                            31139
                        ]
                    ],
                    [
                        [
                            122495,
                            31878
                        ]
                    ],
                    [
                        [
                            125329,
                            30690
                        ]
                    ],
                    [
                        [
                            125192,
                            30787
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    120.153576,
                    29.287459
                ],
                "name": "浙江",
                "childNum": 45
            }
        },
        {
            "id": "340000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@^iuLX^"
                    ],
                    [
                        "@@\u0082e©Ehl"
                    ],
                    [
                        "@@°ZÆëĎµmkǀwÌÕæhºgBĝâ\u008dqÙĊ\u008fz\u009bÖgņtÀÁĂ\u008aÆá\u0092hEz|WzqD¹\u0080\u009f°E\u0087ŧl{ævÜcA`¤C`|´q\u009exĲk\u0081q^³³\u009fGšµb\u0083íZ\u0085¹qpa±ď OH\u0097¦\u0099Ħ\u0088x¢\u0084gPícOl_iCveaOjChß¸iÝ\u008bbÛªCC¿\u0080m\u0084RV§¢A|t^iĠGÀtÚs\u0096d]ĮÐDE¶zAb àiödK¡~H¸íæA\u009eǿY\u0083\u0093j{ď¿\u0091\u0099À½W\u0097®£Ch\u008cÃsi\u008c\u008dkkly]_teu[bFa\u0089Tig\u0087n{]Gqª\u009do\u008bĈMYá|·¥\u007ff¥\u0081\u0097őaSÕė\u0099Nµ\u008dñĞ«Im\u008c_m¿Âa]uĜp \u0085Z_§{C\u0083äg¤°r[_Yj\u0089ÆOdý\u0093[\u008eI[á·¥\u0093Q_n\u0087ùgL¾mv\u0099ˊBÜÆ¶\u009dĊJh\u009ap\u0093c¹\u0098O]iŠ]\u009c¥ jtsggJÇ§\u009dw×jÉ©±\u009bEFË\u008d\u00ad\u0089Ki\u0094ÛÃÕYv\u0085s\u0095\u0088m¬njĻª\u0095§emná}k«ŕ\u0088\u0083gđ²Ù\u009bDÇ¤\u009bí¡ªOy\u009b\u0086×Où±@D\u009fñ\u009dSęćăÕIÕ¿IµĥO\u0089\u0089\u008fjNÕËT¡\u008d¿tNæŇàåyķrĕq§ÄĩsWÆß\u008eF¶\u009d\u009eX®¿\u0089m\u008c\u0099w\u0085RIÞ\u0093fßoG\u0091³\u007f¾©uyH\u0091į{Ɓħ¯AFnuP\u008f\u0085ÍÔz\u009a\u008cV\u0097dàôº^Ðæd´\u007f\u0080\u0087oG¤{S\u0089¬ćxã}\u009bŧ×Kǥĩ«\u009eÕOEÐ·ÖdÖsƘÑ¨[\u0092Û^Xr\u007f¢¼\u0098§xvÄ\u009bÆµ`K\u0094§ tÒ´Cvlo¸fzŨð¾NY´ı~ÉĔē\u0085ßú\u009dLÃÃ\u008f\u0096_ÈÏ|]ÂÏFl\u0094g`b\u009ae\u009e\u009e\u0080n¾¢pU\u0082h~ƴĖ¶_\u0082r sĄ~c\u009e\u0094ƈ]|r c~`¼{À{ȒiJjz\u008f`îÀ\u008dT¥Û³\u0085]\u0092u}\u009bf\u0085ïQl{skl\u0093oNd\u009fj\u009fäËzDvčoQ\u008aďHI¦rb\u0093tHĔ~BmlR\u009a\u0097V_\u0084ħTLnñH±\u0092D\u009e\u009cL\u0091¼L\u0098ªl\u0090§Ťa¸\u008cĚlK²\u0080\\RòvDcÎ\u007fJbt[¤\u0080D@®hh~kt°Ǿz\u008fÖ@¾\u008dªdb\u0084YhüóZ ň¶vHrľ\\Ê\u0097JuxAT|dmÀO\u0084\u008b[ÃÔ\u008bG·ĚąĐlŪÚpSJ¨ĸ\u0088LvÞcPæķŨ\u008e®mÐ\u0090\u0088ál\u009fwKhïgA¢ųÆ©Þ\u0096¤OÈ\u009cm\u0092°\u008cK´\u0090"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            121722,
                            32278
                        ]
                    ],
                    [
                        [
                            119475,
                            30423
                        ]
                    ],
                    [
                        [
                            119168,
                            35472
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    117.283042,
                    31.26119
                ],
                "name": "安徽",
                "childNum": 3
            }
        },
        {
            "id": "350000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@\u0093zht´\u008f\u0087]"
                    ],
                    [
                        "@@aj^~ĆG\u0097\u008f©O"
                    ],
                    [
                        "@@ed¨\u0084C}}i"
                    ],
                    [
                        "@@@v\u0088PGs\u007fQ"
                    ],
                    [
                        "@@\u0089sBz\u0082ddW]Q"
                    ],
                    [
                        "@@S\u008e¨Q\u0093{"
                    ],
                    [
                        "@@N\u008eVucW"
                    ],
                    [
                        "@@qptBAq"
                    ],
                    [
                        "@@\u0089\u0092¸[mu"
                    ],
                    [
                        "@@Q\\pD]_"
                    ],
                    [
                        "@@jSwUadpF"
                    ],
                    [
                        "@@eXª~\u0083\u0095"
                    ],
                    [
                        "@@AjvFso"
                    ],
                    [
                        "@@fT\u0096\u009b_Çí\\\u009f\u0099\u0097v|ba¦jZÆy\u0080°"
                    ],
                    [
                        "@@IjJi"
                    ],
                    [
                        "@@wJI\u0080\u0088x\u009a«¼A\u007foNe{M\u00ad\u0090"
                    ],
                    [
                        "@@K\u0089±¡Ó\u0088\u0094ČäeZ\u0081"
                    ],
                    [
                        "@@k¡¹Eh~c®wBk\u008bUplÀ¡I\u0095~Mā\u008de£bN¨gZý¡a±Öcp©Ph\u009eI\u0094\u009f¢Qq\u0085ÇGj\u009d\u009d\u007f\u008b|¥U\u0099 g[Ky¬\u008d\u008dŏ\u008d\u0096v@Op\u0088tÉE\u009f\u0090F\u0084\u0090\\@ å\u007fA¬\u0088V{Xģ\u0089Đ\u009dBy\u0085cp\u0081ě\u0085¼³Ăp\u008f·¤\u0083¥o\u0093hqqÚ¡ŅLs\u0081\u0083^Ã¡\u0097\u009e§ql\u009fÀhH\u0081¨MCe»åÇGD¥zPO£čÙkJA¼ß\u0096ė\u008fu\u009bĕeûÒ\u008diÁŧ\u0090SW¥\u0098Q\u008aûŗ½ùěcÝ§SùĩąSWó«íęACµ\u009beR\u0097å\u0081ǃRCÒÇZÍ¢\u008bź±^dls\u008ctjD¸\u0095\u0082Zpu\u009eÔâÃ\u0092H¾oLUêÃÔjjēò´ĄW\u0082ƛ\u008d\u0085^Ñ¥\u008bĦ\u009f@Çò\u0096\u008am\u008c\u0083Ow¡õyJ\u0086yD}¢ď\u008fÑÈġf\u008d\u008aZd\u0096a©º²z£\u009aN\u0096\u0083jD°Ötj¶¬ZSÎ~¾c°¶Ðm\u0098x\u0082O¸¢Pl´\u009eSL|¥\u009eA\u0086ȪĖM\u0092ņĲg®áIJČĒü` \u008eQF\u0087¬h|Ă\u0093J@zµ |ê³È ¸UÖŬŬÀEttĸr\u0082]\u0080\u0098ð\u008eM¤ĶĲHtÏ A\u0092\u0086\u009e\u007fĬkvsq\u0087^aÎbv\u008cd\u0096\u0099fÊòSD\u0080´Z^\u0092xPsĂ\u009erv\u008bƞŀ\u0098\u009djJd×ŘÉ ®A\u0096Î¦Ĥd\u0080xĆqA\u008c\u0086ZR\u0094ÀMź\u008cnĊ»\u008cİÐZ\u0097 YX\u0096æJ\u008ayĊ²\u0088·¶q§·\u0096K@\u009d·{s\u0091Xãô«lŗ¶»o\u008f\u0090½E¡\u00ad«¢±¨Y\u0088®Ø\u008b¶^A\u0099vWĶGĒĢ\u009ePl\u007fzf\u0088ļ\u008etàAvWYã\u009aO_\u0087¤sD§ssČġ[kƤPX¦\u008e`¶\u0093\u009e®\u0088BBvĪjv©\u009ajx[L¥àï\u0081[F\u0085¼ÍË»ğV`«\u0095Ip\u0099}ccÅĥZE\u008bãoP\u0085´B@\u007f\u008aD\u007f\u0097¸m±\u0093z«Ƴ\u0097¿å³BRØ¶\u0088\u009cWlâþäą`\u0093]Z\u007f\u008f£T\u007f\u0081c\u0097 ĹGµ¶H\u0099m@_©\u0097k\u008c\u0089¾xĨ\u0087ôȉðX«½đCI\u008f\u007fbćqK³Á\u008bÄš¬OA\u008dwã»aLŉ\u0087ËĥW[\u0093ÂGI\u0097ÂNxĳ¤D¢\u008e\u008fîĎÎB§°_J\u007f\u009cGs\u0083¥E@\u0085¤uć\u0085P\u0091å\u0086c\u0090uMuw¢BI¿\u0087]zG¹guĮck\\_"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            123250,
                            27563
                        ]
                    ],
                    [
                        [
                            122541,
                            27268
                        ]
                    ],
                    [
                        [
                            123020,
                            27189
                        ]
                    ],
                    [
                        [
                            122916,
                            27125
                        ]
                    ],
                    [
                        [
                            122887,
                            26845
                        ]
                    ],
                    [
                        [
                            122808,
                            26762
                        ]
                    ],
                    [
                        [
                            122568,
                            25912
                        ]
                    ],
                    [
                        [
                            122778,
                            26197
                        ]
                    ],
                    [
                        [
                            122515,
                            26757
                        ]
                    ],
                    [
                        [
                            122816,
                            26587
                        ]
                    ],
                    [
                        [
                            123388,
                            27005
                        ]
                    ],
                    [
                        [
                            122450,
                            26243
                        ]
                    ],
                    [
                        [
                            122578,
                            25962
                        ]
                    ],
                    [
                        [
                            121255,
                            25103
                        ]
                    ],
                    [
                        [
                            120987,
                            24903
                        ]
                    ],
                    [
                        [
                            122339,
                            25802
                        ]
                    ],
                    [
                        [
                            121042,
                            25093
                        ]
                    ],
                    [
                        [
                            122439,
                            26024
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    118.306239,
                    26.075302
                ],
                "name": "福建",
                "childNum": 18
            }
        },
        {
            "id": "360000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u008fĢĨƐgļ\u0088¼ÂMD~ņªe^\\^§\u0084ý\u009d©j×\u008dcZ\u0086Ø¨zdÒa\u0090¶\u0088lÒ\u008dJ\u008cìõ`oz÷@\u009d¤uŞ¸´\u0086ôęöY¼\u0089HČƶajlÞƩ¥éZ[\u0094|h}^U \u008c ¥p\u0084ĄžƦO \u007flt¸Æ \u0080Q\\\u0080\u008aaÆ|CnÂOjt\u00adĚĤd\u0092È\u008cF`\u0092¶\u0084@Ðë\u0094 ¦ōÒ\u009e¨Sêv\u0086HĢûXD®\u0085QgÄ\u0097WiØPÞìºr¤ǆ\u0080NĠ¢l\u0096\u0095ĄtZo\u009cCƞÔºCx\u007frpĠV®Ê{f_Y`_\u0083eq\u0092\u0092®Aot`@o\u0082DXfkp¨|\u008as¬\\D\u0091ÄSfè©Hn¬\u0085^DhÆyøJh\u0093ØxĢĀLÊ\u0088\u0084ƠPżċĄwȠĚ¦G®\u008fǒĤäT\u0090ŠÆ~Ħw\u008a«|TF¡\u008an\u0080\u007fc³Ïå¹]ĉđxe{\u008fÎÓ\u0090\u0086vOEm°BƂĨİ|G\u0092vz½ª´\u0080H\u0092àp\u0094eJÝ\u0086Q\u009axn\u008bÀ\u008aW\u00ad\u009e\u009dEµà\u008dXÅĪt¨ÃĖrÄwÀFÎ|ňÓMå¼ibµ¯»åDT±\u008fm[\u0093r«_g\u008emQu~¥V\\OkxtL\u0081 E¢\u008b\u0083\u0091Ú^~ýê\u008bPó\u0096qoě\u008a±\u007f_Êw§ÑªåƗā¼\u008bmĉŹ\u008b¿NQ\u0093\u0085YB\u008bąr\u007fwģcÍ¥B\u0095\u009f\u00adŗÊcØiI\u0097\u009eƝĿu\u008c\u009dqtāwO]\u0091³YC\u007fñTeÉ\u0095\u009a\u008bcaubÍ\u0088]trlu\u0080ī\u0085\u009dB\u0091Ð\u009fGsĵıN£ï\u008d\u007f\u0097\u0081^ķqss¿FūūVÕ\u009f·´Ç{éĈý\u0089ÿ\u009bOE\u0088\u008dR_\u009fđûIċâJh\u00adŅıN\u0091ȩĕB\u0085¦\u009dK{\u009dTk³¡OP·w\u0081n\u0097µÏd¯}½TÍ«YiµÕsC¯\u0084iM\u0095¤\u0099\u00ad\u0095¦\u009d¯P|ÿ\u008dUHv\u0093he¥oFTu\u0089õ\\\u008f\u008eOSs\u008bMòđƇiaºćX\u009fĊĵà\u009d·çhƃ÷Ç\u009c{\u0091ígu^\u009bđg\u0092m[×zkKN\u009d\u0081\u008f\u0091¶Õ\u009d»lčÓ{XSÆ\u0089v©_\u009dÈëJbVk\u0084ĔVÀ¤P¾ºÈMÖxlò~ªÚàGĂ¢B\u0084±\u0092Ì\u008cK\u0098y\u0092áV\u0087¼Ã~\u00ad\u009d\u0085`g\u009b\u009fsÙfI\u009bƋlę¹e|\u0096~udj\u0088uTlXµf`\u0090¿Jd\u008a[\\\u0098\u0084L\u0082\u0091²"
                ],
                "encodeOffsets": [
                    [
                        116689,
                        26234
                    ]
                ]
            },
            "properties": {
                "cp": [
                    115.592151,
                    27.676493
                ],
                "name": "江西",
                "childNum": 1
            }
        },
        {
            "id": "370000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@Xjd]{K"
                    ],
                    [
                        "@@itbFHy"
                    ],
                    [
                        "@@HlGk"
                    ],
                    [
                        "@@T\u0082\u008cG\u009fy"
                    ],
                    [
                        "@@K¬\u0098\u0095\u008bU"
                    ],
                    [
                        "@@WdXc"
                    ],
                    [
                        "@@PtOs"
                    ],
                    [
                        "@@\u0095LnXhc"
                    ],
                    [
                        "@@ppV\u0083u]Or"
                    ],
                    [
                        "@@cdzAUa"
                    ],
                    [
                        "@@udRhnCI\u0087"
                    ],
                    [
                        "@@\u0088oI\u0083\u008fpR\u0084"
                    ],
                    [
                        "@@Ľč{fzƤî\u0092K\u009a\u0096ÎMĮ]\u0086\u0097ZF\u0088½Y]â£ph\u0092\u0099\u009a¶¨râøÀ\u0086ÎǨ¤^ºÄ\u0094Gz\u0088~grĚĜlĞÆ\u0084LĆǆ¢Îo¦\u0096cv\u0093Kb\u0080gr°Wh\u0094mZp \u0088L]LºcU\u0089Æ\u00adn\u0094żĤÌĒ\u009cbAnrOA\u009c´\u009eȊcÀbƦUØrĆUÜø\u009cĬƞ\u0086\u009a\u0098Ez\u0084VL®öØBkŖÝĐĖ¹ŧ̄±ÀbÎÉ\u009cnb²ĦhņBĖ\u009b\u009eįĦåXćì@L¯´yw\u0081ƕCéÃµė ƿ¸\u0091lµ¾Z|\u0086ZWyFY\u009f¨Mf~C¿`\u0080à_RÇzwƌfQnny´INoƬ\u0088èôº|sT\u0084JU\u009a\u009b\u0082L\u0084îVj\u0084ǎ¾ĒØ\u008d\u0082Dz²XPn±\u0090ŴPè¸ŔLƔÜƺ_T\u0091üÃĤBBċÈ\u0089öA´fa\u0084\u0098M¨{«M`\u0087¶\u0081d¡ô\u0089Ö°\u009amȰBÔjj\u008c´PM|\u0094c^d¤u\u0095\u0083¤Û´\u008cä«ƢfPk¶Môl\u0088]Lb\u0084}su\u008f^\u008fke{lC\u0091\u0085M\u0095rD\u008aÇ\u00ad]N\u0081ÑFsmoõľH\u0089yGă{{çrn\u009dÓE\u0089\u008bƕZGª¹Fj¢ï\u008fW\u0085uø\u007fCǷë\u008f¡ąuhÛ¡^Kx\u0095C`\u007f\u008fC\\bÅxì²ĝÝ¿_N\u0089īCȽĿåB¥¢·IŖÕy\u008d\\\u0087¹kx\u0087Ã£\u008fČ×GDyÃ\u0095¤ÁçFQ¡\u0084KtŵƋ]CgÏA\u009d\u008fùSed\u0087cÚź\u0097\u008auYf\u0083yMmh\u0081UWp\u008fS\u008dyG\u008fwMPqŀ\u0097\u009bÁ¼zK\u009b¶\u0086G\u0095\u00adY§Ë\u0083@\u0096´śÇµƕ\u0081Bm\u009c\u0081@Io\u0082g\u0097\u0097Z\u008f¯u\u008bTMx\u0081}C\u0091\u0089VK\u0082ï{éƵP\u0097\u0099_K«\u0099pÛÙqċtkk\u007fù]g\u008e\u008bTğwo\u0095ɁsMõ³ă\u0087AN£\u0099MRkmEÊ\u0095č\u0099ÛbMjÝGu\u008f\u0085IZ\u0099\u0097GPģ\u0087ãħE[iµBEu\u009fDPÔ\u009b~ª¼ęt\u008a\u009c]\u008cûG§\u0080¡QMsğNPŏįzs\u009d£Ug{đJĿļā³]ç«Qr~¥C\u008dƎÑ^n¶\u008dÆéÎR~Ż¸Y\u0092I\u0093] P\u0089umŝrƿ\u009b\u0089\u009bIā\u008b[x\u0089eÇ³\u008f\u008bL\u0091¯\u008fv¯s\u009d¬ÁY\u0085~}\u0085ťuŁ\u008cg\u009bƋpÝĄ_ņī¶ÏSR´ÁP~\u009e¿Cy\u009eċ\u0081ßdwk\u009d´Ss\u0095X|t\u0089`Ä \u008dÈð\u0080AªìÎT°¦Dd\u0096\u0080a^lĎDĶÚY°\u008e`ĪŴǒ\u0088\u0094àŠv\\\u0090eb\u008cZH\u0084ŖR¬ŢƱùęO\u0095\u008fÑM\u00ad\u009d³FÛ\u0083Wp[\u0083"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            123806,
                            39303
                        ]
                    ],
                    [
                        [
                            123821,
                            39266
                        ]
                    ],
                    [
                        [
                            123742,
                            39256
                        ]
                    ],
                    [
                        [
                            123702,
                            39203
                        ]
                    ],
                    [
                        [
                            123649,
                            39066
                        ]
                    ],
                    [
                        [
                            123847,
                            38933
                        ]
                    ],
                    [
                        [
                            123580,
                            38839
                        ]
                    ],
                    [
                        [
                            123894,
                            37288
                        ]
                    ],
                    [
                        [
                            123043,
                            36624
                        ]
                    ],
                    [
                        [
                            123344,
                            38676
                        ]
                    ],
                    [
                        [
                            123522,
                            38857
                        ]
                    ],
                    [
                        [
                            123628,
                            38858
                        ]
                    ],
                    [
                        [
                            118260,
                            36742
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    118.000923,
                    36.275807
                ],
                "name": "山东",
                "childNum": 13
            }
        },
        {
            "id": "410000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u0095ýL\u0099ùµP³swIÓxcŢĞð\u0086´E®\u009eÚPt\u0086ĴXØxÂ¶\u0098@«ŕŕQG\u0083\u008bYfa[\u008fşu\u0093ßǩ\u0099đš\u008d_X³ĳÕčC]k\u007fbc\u0095¥CS¯ëÍB©÷\u008b\u0096³\u00ad\u0081Si\u0088_}m\u0098YTt\u009e³xlàcČ\u0082z\u009dÀD}\u009dÂOQ³ÐTĨ¯\u0086ƗòËŖ[h\u009cł\u008bŦv~\u0086\u0086}ÂZ\u009e«¤lPÇ\u0095£ªÝŴÅR§Ønhc\u008ctâk\u008f\u0087nÏ\u008d\u00adľŹUÓÝdKuķ\u0087I§oTũÙďkęĆH¸Ó\u008c\\Ä\u0083\u008c¿PcnS{wBIvÉ\u0098Ľ[Gqµu\u009fŇôYgû\u0083Zca\u008e©@½\u0090Õǽys¯}lgg@\u00ad\u007fC\\£as\u0080IdÍuCQñ\u007f[L±ęk·\u008bţb\u008f¨©kK\u0097\u0092»\u009bKC\u009d²\u0091òGKmĨS`\u0083\u0098UQ\u0099nk}AGē\u0094sqaJ¥ĐGR\u0089ĎpCuÌy ã iMc\u0094plk|tRk\u0086ð\u009cev~^\u0091´\u0086¦Ü\u008eSí¿\u0090_iyjI|ȑ|¿_»d}q\u009f^{\u0093Ƈd\u009dă}\u009ft\u0081qµ`Ƴĕg}V\u0081¡om½\u009d\u007ff\u009da\u0099Ço³TTj¥\u0084tĠ\u0097Ry\u0094\u008fK{ùÓjuµ{t}uËR\u0091i\u009fvG\u008açJFjµ\u008aÍyqÎ\u0098àQÂ\u007fFewixGw½Yŷpµú³X\u009dU\u009b½ġy\u0099łå\u0089kÚwZX\u0088·l\u0084¢Á¢K\u0094zO\u0084Î\u009bÎ\u0080jc¼htoDHr\u0085|\u00adJ\u0093½}JZ_¯iPq{tę½ĕ¦Zpĵø«kQ\u0085Ĺ¤\u0083]M\u008dÛf\u0081aQpě±ǽ¾]u\u00adFu\u008b÷n\u0083\u0099čÄ¯ADp}AjmcEÇ\u0092aª³o³ÆÍSƇĈÙDIzË\u0091čľ\u009f^\u0088KL\u009c\u0097i\u0097Þñ\u0080[\u009c\u0083aA²zz\u0089Ì÷D\u009c|[\u009aíÄ³gf\u0082ÕÞd®|`\u0083Ć~\u0084oĠƑô³Ŋ\u0091D×°¯Cs\u008aøÀ«ì\u0089UMhTº¨¸ǡîS\u0096Ô\u0084DruÂÇZ\u0095ÖE\u008e\u0092v\u008dPZ\u0084\u009eW\u0094~Ø\u008bÐtĄE¢¦Ðy¸b\u008aô´oŬ¬\u008e²Ês~\u0080\u0080]®tªa\u009apŎJ¨Öº\u0084_\u008aŔ\u0096`\u0092Ŗ^Đ\u008d\\Ĝu\u0096\u0094~m²Ƹ\u009b¸fW\u0089ĦrƔ}Î^gjdfÔ¡J}\\n C\u0098¦þWx\u0090ªJRÔŠu¬ĨĨmF\u0086dM{\\d\\\u008aYÊ¢ú@@¦ª²S\u008aÜsC\u0096}fNècbpRmlØ^g\u0084d¢aÒ¢CZ\u0088\u008dZxv\u0081Æ¶N¿\u0092¢T@\u0080uC\u009c¬^Ċð\u0081Än|\u008f\u009elGl\u0092\u0099Rjsp¢ED}\u0080Fio~\u007fÔN\u008e\u008b\u0084~zkĘHVsǲßj\u0083Ŭ\u008c\u008a\u007fŢ`Pûàl¢\u0098\\À\u009cEh\u008eİgÞē X\u0090¼Pk\u0096\u0084|m"
                ],
                "encodeOffsets": [
                    [
                        118256,
                        37017
                    ]
                ]
            },
            "properties": {
                "cp": [
                    113.665412,
                    33.757975
                ],
                "name": "河南",
                "childNum": 1
            }
        },
        {
            "id": "420000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@A\u0081B\u0082"
                    ],
                    [
                        "@@lskt"
                    ],
                    [
                        "@@¾«}{ra®pîÃ\\\u0099\u009b{øC\u008aËyyB±\u0084b\\\u009bò\u007f\u0098Ý\u0098jK\u009b\u0087L ]ĎĽÌ\u0092JyÚCƈćÎT´Å´pb©È\u0091dFin~BCo°BĎÃ\u0084\u009aømv\u008c®E^vǾ½Ĝ²Ro\u0082bÜeN\u008e\u0084^ĺ£R\u0086¬lĶ÷YoĖ¥Ě¾|sOr°jY`~I\u0094¾®I\u0086{GqpCgyl{\u0087£\u009cÍ\u0083ÍyPL\u0093Â¡\u0083¡¸kW\u0087xYlÙæ\u008a\u009aŁĢz\u009c¾\u009eV´W¶ùŸo¾ZHxjwfx\u0084GNÁ\u0095³Xéæl¶\u0089EièIH\u0089 u\u0092jÌQ~v|sv¶Ôi|ú¢Fh\u008d\u0098Qsğ¦\u0083SiŠBg\u0099ÐE^ÁÐ{\u0096čnOÂÈ\u009eUÎóĔ\u0086ÊēĲ}Z³½Mŧïeyp·uk³DsÑ¨\u009fL\u0093¶_\u009cÅuÃ¨w»\u0097\u0080¡WqÜ]\\\u0091Ò§tƗcÕ¸ÕFÏǝĉăxŻČƟO\u0087\u0083KÉġÿ×wg\u0094÷IÅzCg\u0086]m«ªGeçÃTC\u0092«[\u0089t§{loWe\u0081C@ps_Bp\u0091\u00adr\u0091\u0084f_``Z|ei¡\u0097oċMqow\u0080¹DƝÓ\u009bDYpûs\u0095\u0096\u008bYkıǃ}s¥ç³[§\u009fcY\u008a§HK\u0084«Qy\u0089]¢\u0093wwö\u0080¸ïx¼ņ¾Xv®ÇÀµRĠÐ\u008b\u009e\u0081HM\u009e±cÏd\u0084ƒǍũȅȷ±DSy\u0081úĝ£\u008dŤĀàtÖÿï[îb\\}pĭÉI±Ñy\u0085¿³x¯N\u0089o\u0089|¹H\u0099ÏÛm\u008b\u009djúË~T\u009a\u009d\u0095u\u0098ęjCöAwě¬R\u0092đl¯ Ñb\u00ad\u0089ŇT\u007f\u0086Ŀ_[\u008c\u0091IčĄʿnM¦ğ\\É[T·\u0099k¹\u009c©oĕ@A\u008f¾w\u0095ya¥\u0090Y\\¥Âaz¯ãÁ¡k¥ne£Û\u007fw\u0086\u009dE©Êō¶˓u\u008foj_U\u0083¡cF¹\u00ad[Wv\u0093P©w\u0097huÕyBF\u0093\u0083`R\u008bqJUw\\i¡{j\u009f\u009fEPïÿ½fć\u0085QÑÀ\u0081Q{\u009e\u0082°\u0087fLÔ\u0081~wXg\u0097ī\u0081têÝ¾\u0096ĺ\u0091Hd\u0088³fJd]\u008b\u008dHJ²\u0085E\u0080\u0083oU¥\u0086HhwQsƐ»Xmg±çve\u009b]DmÍ\u0082P\u0088oCc¾\u008b_h\u0094\u0096høYrŊU¶eD°Č_N~øĹĚ·`z\u0092]Äþp¼\u0085äÌQ\u008cv\\rC\u008cé¾TnkžŐÚ\u0080Üa\u0087\u0093¼ÝƆĢ¶Ûo\u0085d\u0085ĔňÐ¢Jq\u0092Pb ¾|J\u008c¾fX\u008aƐîĨ_Z¯À}úƲ\u008bN_ĒÄ\u008a^\u0084\u0091ĈaŐyp»CÇÄ\u0095K\u008a\u009añL³\u008aġM\u008c²wrIÒŭxjb[\u009c\u009en«ø\u009c\u0098\u0097æ\u0088à\u0083 ^²\u00adh¯Ú\u0080ŐªÞ¸\u0080Y²ĒVø}Ā^İ\u0099´\u0082L\u008aÚm\u0090\u0084¥ÀJÞ{JV\u008cųÞŃx×\u007fsxxƈē ģMř\u0096ÚðòIf\u0096Ċ\u0093Œ\\Ʈ±ŒdÊ§ĘD\u0086vČ_Àæ~D\u008cċ´A®µ\u0086¨ØLV¦êHÒ¤"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            113712,
                            34000
                        ]
                    ],
                    [
                        [
                            115612,
                            30507
                        ]
                    ],
                    [
                        [
                            113649,
                            34054
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    113.298572,
                    30.684355
                ],
                "name": "湖北",
                "childNum": 3
            }
        },
        {
            "id": "430000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@\u0097n\u0084FTs"
                    ],
                    [
                        "@@ßÅÆá\u0089½ÔXr\u0097\u0086CO\u0099\u0090\u0093\u0085ËR\u0091ïÿ\u008dĩ\u00adTooQy\u009aÓ[\u008bŅBE¬\u0096ÎÓXa\u0084į§Ã¸G °ITx\u008dp\u0089úxÚĳ¥Ï\u009a\u0096Ģ¾\u008aed\u009eÄ©ĸ\u008fG\u0085\u009càGh\u0082\u0080M¤\u0096Â_U}Ċ}¢pczf\u008aþg¤\u0080\u0094ÇòAV\u0091\u008bM"
                    ],
                    [
                        "@@\u0090©K\u0081\u0097\u0083A·³CQ±Á«³BU\u008aƑ¹A\u008a\u008dtćOw\u0090\u0099D]\u008c\u009dJiØSm¯b£\u0091yl\u0083\u009bX\u0085\u008dHËÑ±H\u0095«\u0081\u0096\u0091C^õľA\u0096\u009dÅ§¤É\u008f¥\u0084ïyuǙuA¢\u008d^{ÌC´\u00ad¦ŷJ£^[\u0086\u008f\u009d\u0093ª¿\u0087ĕ~\u0095Ƈ\u0085\u0095N\u0085 skóā\u008d\u0087¹¿\u0080ï]ă~÷O§\u00ad@\u0097\u009dVm¡\u008bQđ¦¢Ĥ{ºjÔ\u008f\u008e\u008cª¥nf´\u0095~Õo\u009f\u009e×Ûą\u008bMąıuZ\u009cmZcÒ ĲĪ²SÊǄŶ¨ƚ\u0083\u0092CÖŎªQØ¼rŭ\u008e\u00ad«}NÏürÊ¬\u008cmjr\u0080@ĘrTW \u00adSsdHzƓ^ÇÂyUi¯DÅYlŹu{hT\u009c}mĉ\u0096¹¥\u009dě\u0089Dÿë©ıÓ[Oº£\u009e\u0093¥ót\u0080ł¹MÕ\u0084\u009eƪ\u0083`P\u009a\u0085Di\u0096ÛU\u008a¾Åâ\u0080\u008cì\u0088U\u0092ñB\u0093È£\u007fýhe\u0089dy¡oċ\u0080`pfmjP~\u0082kZa\u0085\u008dZsÐd°wj§\u0083@\u0080Ĵ®w~^\u0082kÀÅKvNmX\\¨\u0081a\u0093\u0094Ń\u0081qvíó¿F\u0084¤¡@ũÑVw}S@j\u009d}\u0081¾«pĂr\u0096ªg àÀ²NJ¶¶D\u0090ô\u0085K\u0082|^\u007fª\u0086\u008e\u0081°LX¾ŴäPĪ±\u009c£EXd\u009b\u0094^¶\u009bĲÞÜ\u0093~\u0091u¸ǔ\u0098\u008e\u009bMRhsR\u0085e\u007f\u0086`ÄofIÔ\\Ø  i\u0094ćymnú¨cj ¢»\u0096GČìƊÿÐ¨XeĈĀ¾Oð Fi ¢|[jVxrIQ\u008c\u0084_E\u0094zAN¦zLU`\u009ccªx\u0094OTu RLÄ¢dV\u0084i`\u0090p˔vŎµªÉ\u009eF~\u0083Ø\u0080d¢ºgİàw¸Áb[¦\u008fZb¦\u0096z½xB\u0090Ė@ªpº\u009b\u009alS¸Ö\\Ĕ[N¥ˀmĎă\u0092J\\\u008bŀ`\u0080\u0085ňSÚ\u008aĖÁĐiO\u0093Ĝ«BxDõĚiv\u0097\u009e\u0096S\u0099Ì}iù\u008c\u009eÜn\u009aÐºG\u008a{\u008ap°M´w\u0086ÀÒzJ²ò¨ oTçüöoÛÿñ\u008eőĞ¤\u0082ùTz²CȆȸǎŪ\u0083ƑÐc°dP\u009dÎ\u009fğË¶[È½u¯½WM¡\u00adÉ\u009e\u0093\u0092B\u007f·rí\u009enZ\u009fÒ `\u0087¨GA\u0081¾\\pē\u0098XhÃ\u0086RC\u00adüWGġu\u0085Té\u009d§ŎÑ\u009d©ò³I±³}_\u0091\u008bE\u008dÃħg®ęisÁPDmÅ{\u0089b[\u007f\u007fRÅ\u009fs·\u0080kP\u009fŽƥ\u0083óRo\u0094O\u008b\u009fV\u009f~]{g\\\u0093êYƪ¦kÝbiċƵ\u008aGZ»Ěõ\u0085ó·³vŝ\u009e£ø@pyö_\u008bë\u008eIkÑµ\u0087b\u008fcÑ§y\u0085×dYØ\u008eªiþ\u009e¨\u0083[]f]Ņ©C}ÁN\u0087»hĻħƏ\u0092ĩ"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            115640,
                            30489
                        ]
                    ],
                    [
                        [
                            112543,
                            27312
                        ]
                    ],
                    [
                        [
                            116690,
                            26230
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    111.782279,
                    28.09409
                ],
                "name": "湖南",
                "childNum": 3
            }
        },
        {
            "id": "440000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@Qd\u0088Aua"
                    ],
                    [
                        "@@\u0083lxDLo"
                    ],
                    [
                        "@@sbhNLo"
                    ],
                    [
                        "@@Ă ā\u009f"
                    ],
                    [
                        "@@WltO[["
                    ],
                    [
                        "@@Kr\u009c]\u008fS"
                    ],
                    [
                        "@@e\u0084\u0084I]y"
                    ],
                    [
                        "@@I|\u0084Mym"
                    ],
                    [
                        "@@\u0083Û³LS\u008c\u0090\u009e¼Y"
                    ],
                    [
                        "@@nvºB\u0096ëui©`\u009d¾"
                    ],
                    [
                        "@@zd\u009aÛ\u009bJw®"
                    ],
                    [
                        "@@\u0086°\u0085¯"
                    ],
                    [
                        "@@a yAª¸ËJIxØ\u008c@\u0080ĀHAmÃ\u009fV¡o\u0095fu\u0095o"
                    ],
                    [
                        "@@\u009as\u0089ŗÃÔėAƁ\u009bZ\u009aÄ ~°ČP\u0082\u008bäh"
                    ],
                    [
                        "@@\u008b¶Ý\u0092Ì\u0082vmĞh\u00adı\u0087Q"
                    ],
                    [
                        "@@H\u009c\u008adSjĒ¢D}war\u0085\u0093u«ZqadY\u007fM"
                    ],
                    [
                        "@@el\u008c\\LqqU"
                    ],
                    [
                        "@@~rM\u008do\\"
                    ],
                    [
                        "@@f\u0084^\u007f\u0083C"
                    ],
                    [
                        "@@øPªoj÷ÍÝħXČx\u0094°Q¨ıXNv"
                    ],
                    [
                        "@@gÇƳ\u0088\u008e\u0088\u0094o\u0088\u008a\u0088[~tly"
                    ],
                    [
                        "@@E\u0096ÆC¿\u0091"
                    ],
                    [
                        "@@O\u008eP\u008d"
                    ],
                    [
                        "@@w\u008b\u0086đóg\u0089\u0099ĝ\u0097[³\u008b\u0081¡VÙæÅöMÌ³¹pÁaËýý©D©Ü\u0093JŹƕģGą¤{Ùū\u0085Ç\u0098O²«BƱéA\u0097Ò\u0089ĥ\u0087¡\u008f«BhlmtÃPµyU¯uc\u0093d·w_bŝcīímGO\u008e|KP\u0092ȏ\u0087ŹãŝIŕŭŕ@Óoo¿ē\u008b±ß}\u008e\u0085ŭ\u0082\u009fĲWÈ\u007fCőâUâǙI\u009bğŉ©I\u009b\u008dĳE×\u0085Á\u0094³Aó\u009bwXJþ±Ì\u008cÜÓ\u0094\u007fĨ£L]ĈÙƺZǾĆĖMĸĤf\u008cÎĵl\u0095ŨnÈ\u0088\u0091ĐtF\u0094\u008a\u0096FĤ\u0096\u0082êk¶\u009c^k°f¶g\u008a\u008e\u009c}®Fa\u0098f`\u008dvXŲ\u008dxl\u0098\u0084\u007f¦\u0096ÔÁ²¬Ð\u009f¦pqÊÌ²\u0088i\u0080X\u009fØ\u007fRDÎ}\u0086Ä@ZĠ\u0092s\u0084x®AR~®ETtĄZ\u0086\u0096\u007f\u0090ƈfŠŠHâÒÐA\u0086µ\\S¸\u0084^wĖkRz\u008aal\u008eŜ|E¨ÈNĀňZT\u008c\u0092pBh£\\\u008cĎƀuXĖtKL\u0096¶G|\u008e»ĺEļĞ~ÜĢÛĊr\u0088O\u0098Ùîvd]\u0090n\u0088¬V\u009cÊĜ°RÖ\u009fpM\u0086\u0086\u0096\u0082ƂªFbw\u009eEÀ\u0088\u0098©\u008c\u009e\\\u0085¤]ŸI®¥D³|Ë\u008e]C\u009döAŤ¦\u0085æ\u0092´¥¸Lv¼\u0080\u0095¢ĽBaô\u0096F~\u0097\u009a®²GÌÒ\u0090EY\u0084\u0084\u009czk¤\u0092°ahlVÕ\u009eI^\u008b\u009aCx\u008fĈP\u008esB\u0089ƒºV\u0089¸@¾ªR²ĨN]\u008d´_eavSi\u0087vc\u0095}p}Đ¼ƌkJ\u009cÚe th\u009c\u0086_¸ º\u007fx±ò_x\u008dN\u009bË\u008b²\u0091@\u0083ă¡ßH©Ùñ}wkNÕ¹ÇO½¿£ĕ]ly_WìI\u009eÇª`\u008auTÅxYĒÖ¼kÖ\u009e\u0092µ\u0082\u0090M\u009ejJÚwn\\h\u0091\u009cĒv]îh|\u0092È\u009bƄøèg\u009e¸Ķß ĉĈWb¹ƀdéĘ\u008cNTt\u008dP[\u0090\u008aöSvrCZ\u009e\u009eaGu\u009cbo´Ŗ\u0081ÒÇĐ\u0090~¡zCI\u0085özx¢\u0084Pn\u008b\u0095\u0089Èñ @\u008cĥÒ¦\u0086]ƞ\u008aV}³ăĔñiiÄÓVépKG½Ä\u0091Óáv\u009dYo\u0096\u0081C·sit\u008biaÀy\u0084ŧÎ¡ÈYDÑům}\u0089ý|m[węõĉZÅxUO}÷N¹³ĉo_qtă\u0093qwµŁYÙ\u0084ǝŕ¹tï\u009dÛUÃ¯mRCº\u0085\u0088ĭ|µ\u0081\u009bÕÊK\u0099½R\u0091ē ó]\u0091\u0096GªęAx\u0096»HO£\u008f|ām\u0087¡diď×Yï\u008dYWªŉOeÚtĐ«zđ¹T\u0085ā\u0087úE\u0099á²\u007f\\\u008bķÍ}jYàÙÆſ¿Çdğ·ùTßÇţʄ¡XgWÀǇğ·¿Ã\u0088Oj\u0090 YÇ÷Qě\u008bi"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            117381,
                            22988
                        ]
                    ],
                    [
                        [
                            116552,
                            22934
                        ]
                    ],
                    [
                        [
                            116790,
                            22617
                        ]
                    ],
                    [
                        [
                            116973,
                            22545
                        ]
                    ],
                    [
                        [
                            116444,
                            22536
                        ]
                    ],
                    [
                        [
                            116931,
                            22515
                        ]
                    ],
                    [
                        [
                            116496,
                            22490
                        ]
                    ],
                    [
                        [
                            116453,
                            22449
                        ]
                    ],
                    [
                        [
                            113301,
                            21439
                        ]
                    ],
                    [
                        [
                            118726,
                            21604
                        ]
                    ],
                    [
                        [
                            118709,
                            21486
                        ]
                    ],
                    [
                        [
                            113210,
                            20816
                        ]
                    ],
                    [
                        [
                            115482,
                            22082
                        ]
                    ],
                    [
                        [
                            113171,
                            21585
                        ]
                    ],
                    [
                        [
                            113199,
                            21590
                        ]
                    ],
                    [
                        [
                            115232,
                            22102
                        ]
                    ],
                    [
                        [
                            115739,
                            22373
                        ]
                    ],
                    [
                        [
                            115134,
                            22184
                        ]
                    ],
                    [
                        [
                            113056,
                            21175
                        ]
                    ],
                    [
                        [
                            119573,
                            21271
                        ]
                    ],
                    [
                        [
                            119957,
                            24020
                        ]
                    ],
                    [
                        [
                            115859,
                            22356
                        ]
                    ],
                    [
                        [
                            116561,
                            22649
                        ]
                    ],
                    [
                        [
                            116285,
                            22746
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    113.280637,
                    23.125178
                ],
                "name": "广东",
                "childNum": 24
            }
        },
        {
            "id": "450000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@H\u0096 TQ§\u0095A"
                    ],
                    [
                        "@@ĨÊª\u0083L\u0083ƊDÎĹĐCǦė¸zÚGn£¾\u009brªŀÜt¬@Ö\u009bÚ\u0088Sx~øOŒ\u0098ŶÐÂæȠ\\\u0084ÈÜObĖw^oÞ\u0084Lf¬°bI lTØBÌ\u0088F£Ć¹gñĤaY\u0093t¿¤VSñ\u009cK¸¤nM\u0086¼\u0082JE±\u0084½¸\u009a\u008año\u008bÜCƆæĪ^\u008aĚQÖ¦^\u0087\u0088\u0088f´\u0081Q\u0086üÜÊ\u009dz¯\u009alzUĺš@ì\u0087\u0080p¶n]sxtx¶@\u0081\u0084~ÒĂJb©gk\u0082{°\u0082~c°`Ô\u0099¬rV\\\u0093la¼¤ôá`¯¹\u009dLC\u0086Æb\u008cxEræO\u0090\u0082v[H\u00ad\u0098\u0084[~|aB£ÖsºdAĐzNÂðs\u008eÞÆ\u0094\u0085Ĥªb\u0083\u0096ab`ho¡³F«èVlo\u008e¤\u0099ÔRzpp®S\u008eĪº¨Ö\u0083ºN\u0085ĳ\u0084\u007fd`\u0092a\u0094¦¤\u009dF³ºDÎńĀì\u008aC\u009eĜº¦Ċ\u0095~nS\u009b|gźvZkCÆj°zVÈÁƔ]L\u008dÊFZg\u0085čP\u00adkini«\u008bqÇ\u0080czÍ\u0094Y®¬Ů\u008d»qR×ō©DÕ\u0084\u0091§ƙǃŵTÉĩ±\u009fıdÑnYY\u009bĲvNĆĆ\u008cØÜ \u009dÖp\u0096}e³¦m\u008b©\u0090\u008diÓ|¹\u009fħņ\u009b|ª¦QF¢Â¬ʖovg¿em\u0087^\u008fucà÷gÕ\u008eu\u008cíÙćĝ}FĻ¼Ĺ{\u008dµHK\u0095sLSđƃr\u008bč¤[Ag\u0091oS\u008bŇYMÿ§Ç{F\u008dśbky\u0089lQxĕ\u0083]T·¶[B\u0085ÑÏGáşşƇe\u0080\u008f\u0085\u0095ăYSs\u00adFQ}\u00adB\u0083w\u0091tYğÃ@~\u0085CÍ\u0080Q ×\u007fW\u0087jË±rÉ¥oÏ ±«ÓÂ¥\u0095\u0083\u0080k\u0097\u008ewWű\u008cmcih\u008f³K\u009b~\u0089\u008dµh¯e]lµ\u009bél\u0095\u0081Eģ\u0089\u0095E\u0093ďs\u0087\u0092mÇ\u0096ŧē`ãògK_ÛsUʝ\u0093ć\u008fğ¶h\u008cö\u008cO¤Ǜn³\u008e\u009dc\u0091`¡y\u008b¦C\u0091\u0081ez\u0080Y\u008awa\u0099\u0096\u0091[ďĵűMę§]X\u0098Î_\u0082í\u009b\u0098\u008dÛ]é\u0092ÛUćİÕBƣ±\u0085d\u0083y¹T^d\u0081\u009eûÅÑŦ·\u0087\u007fPĻþÙ`K\u0080¦\u0098\u0085¢Íe\u0081\u009cĥR¿\u008c³£[~\u008cäu¼dl\u0089t\u0082\u0086W¸oRM¢ď\\z\u009c}Æzdvň\u0096{ÎXF¶°Â_\u0084ÒÂÏL©Ö\u0095Tmu\u009f¼ãl\u0089\u009bīkiqéfA\u0084·Êµ\\őDc¥ÝF\u0093y\u009bÔć\u0098c\u0080űH_hLÜ\u008bêĺĐ¨c}rn`½\u0084Ì@¸¶ªVL\u008c\u008ahŒ\u008b\\\u0095Ţĺk~\u008eĠið°|g\u008ctTĭĸ^x\u0091vK\u0098\u008fVGréA\u0081é\u0091bUu\u009bMJ\u0090\u0089VÃO¡\u0085qĂ\u007fXËS\u0089ģãlýà\u009f_ju\u0087YÛÒB\u0086\u009cG^\u0098éÖ\u008a¶§\u008e\u0083EG\u0094Åzě\u0083Ư¤Ek\u0087N[kdåucé¬dnYp\u008fAyČ{`]þ¯T\u0092b\u0090ÜÈk\u0082¡Ġ\u0095v\u008càh\u0084ÂƄ¢Jî¶²"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            111707,
                            21520
                        ]
                    ],
                    [
                        [
                            107619,
                            25527
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    108.320004,
                    22.82402
                ],
                "name": "广西",
                "childNum": 2
            }
        },
        {
            "id": "460000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u009a¦Ŝil¢\u0094XƦ\u0091ƞò\u0096ïè§ŞCêɕrŧůÇąĻõ\u0099·ĉ³œ\u0081̅k\u007fÇm@ċȧ\u0083ŧĥ\u0089Ľʉ\u008d\u00adƅſ\u0093ȓÒË¦ŝE}ºƑ[ÍĜȋ gÎfǐÏĤ¨ê\u009dƺ\\Ɔ¸ĠĎvʄȀ\u009cÐ¾jNðĀÒR\u008c\u009aZǆ\u0099zÐŘÎ°H¨\u008dƢb²_Ġ "
                ],
                "encodeOffsets": [
                    [
                        112750,
                        20508
                    ]
                ]
            },
            "properties": {
                "cp": [
                    109.83119,
                    19.031971
                ],
                "name": "海南",
                "childNum": 1
            }
        },
        {
            "id": "510000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@LqKr"
                    ],
                    [
                        "@@\u008a[ĻéV£\u009e_ţġñpG \u0095réÏ·~ąSfy×Í\u0082·º\u008fſƽiÍıƣıĻmHH}siaX@iÇ°ÁÃ×t«\u0083\u00adT\u0083¤J\u0096\u007fJJ\u008cyJ\u0095È\u008a`Ohß¦¡uËhI\u007fyCjmÿw\u0085ZG\u0085\u0085Ti\u008bS\u0088sO\u0089\u009eB²\u009ffNmsPa\u0088{M{\u008aõE\u0091^Hj}gYpaeu\u009e¯\u0091oáwHjÁ½M¡pM\u0093\u0096uå\u0087mni{fk\u0094\\o\u0083ÎqCw\u0086EZ\u0081¼K\u009bĝ\u008a\u0083Ay{m÷L\u0087wO×SimRI\u008d¯rK\u0099õBS«sFe\u0087]f\u007fµ¢óY_ÆPRcue°Cb\u0081o×\u008cbd£ŌIHgtrnyPt¦foaXďx\u009blBowz\u008b_{ÊéWiêE\u0084\u0081GhÜ¸ºuF\u009dĈIxf®\u007f\u008e\u0095Y½ĀǙ]\u0081¤\u009dEy\u009fF\u008d²ċ\u0092w¸¿@g¢§RGv»\u0096\u0081á\u009fW`ÃĵJwi]t¥wO\u00ad½a[×\u0088]`Ãi\u00adü\u008fL\u0080¦LabbTÀå\u0092c}Íh\u0099Æh\u0088\u008b®BH\u0080î|î\u0083ºÉk\u00ad¤S\u0086\u009dy£\u0084ia©taį·Ɖ`ō¥Uh\u0093O\u0085\u0083ĝLk}©Fos\u0089´\u009bJm\u0084µlŁu\u009d\u0097\u0085ø\u0096nÑJWÎª\u0096YÀïAetT\u009eŅ\u0082Ó\u008dG\u0099Ë«bo\u0089{ıwodƟ½\u0083\u009e\u0081OġÜ\u0091ÂµxàNÖ¾P²§HKv¾\u0096]|\u0095B\u0087ÆåoZ`¡Ø`ÀmºĠ~ÌÐ§nÇ\u0085¿¤]wğ@s\u0083\u0089rğu\u0089~\u0091Io\u0094[é±¹ ¿\u009eſđÓ\u0089@q\u008bg\u0088¹zƱřaí°KtÇ¤V»Ã[ĩǭƑ^ÇÓ@áť\u0097s\u009bZÏ\u0095\u008b\u009cÅĭ\u0080Ƌ\u0095ěpwDóÖá\u0088ŻneQË\u008c\u009dq·\u0095GCœýS]x\u009f·ý\u008bq³\u0095OÕ\u009c\u008c¶Qzßti{ř\u0089áÍÇWŝŭñzÇW\u008bpç¿J\u008c\u0099\u0082X\u009cĩè½c\u008d\u008cF\u0096ÂLiVjx}\\N\u0086ŇĖ¥Ge\u0096\u0093JA¼ÄHfÈu~¸Æ«dE³ÉMA|\u0081b\u0098Ò\u0085\u0098ćhG¬\u007fCM\u0082õ\u008a\u0084ƤąA\u007fv\u0083üV\u0080éŀ\u0089_VÌ³ĐwQj´·ZeÈÁ¨X´\u008dÆ¡Qu·»\u009f\u0093\u0098ÕZ³ġqDo\u0089y`L¬gdp°ş\u008ap¦ėìÅĮZ\u008e°Iä\u0094h\u0082\u0091\u0088z\u008aĵ\u009cf²å \u009bĚÑ\u0080Kp\u008bIN|\u008b\u0084Ñz]ń\u0085\u0085·FU×é»R³\u0099M\u0083É»GM«\u0080\u008fki\u0080\u007f\u0099ér\u0099}Ã`¹ăÞmÈ\u009dnÁîRǀ³ĜoİzŔwǶVÚ£À]ɜ»ĆlƂ²Ġ\u0085þTº·àUȞÏʦ¶\u0086I\u0092«dĽĢdĬ¿\u0096»Ĕ×\u008ah\\c¬\u0086ä²GêëĤł¥ÀǿżÃÆMº}BÕĢyFVvw\u0096\u0088xBèĻĒ©Ĉ\u0093tCĢɽŠȣ¦āæ·HĽî\u0093ôNÔ\u0093~^¤Ɗ\u009cu\u0084\u009c^s¼{TA¼ø°¢İªDè¾Ň¶ÝJ\u0091®Z´ğ~Sn|ªWÚ©òzPO\u0090ȸ\u0082bð¢|\u008bøĞ\u008a\u008c\u009cŒQìÛÐ@Ğ\u0099ǎRS\u007f¤Á\u007f§d\u0085i\u0093´ezÝú\u008fØã\u008f]Hq\u0084kI\u009fþËQÇ¦ÃsÇ¤[E\u009d¬ÉŪÍxXƒ·ÖƁİlƞ¹ª¹|XÊwn\u0091ÆƄmÀêErĒtD®ċæcQ\u0083\u0094E®³^ĭ¥©l}äQto\u0098ŖÜqÆ\u008ekµ\u0096\u0084ª\u008fÔĻĴ¡@Ċ°B\u007f²Èw^^RsºTĀ£Śæ\u009cQP\u0091JvÄz\u0084\u0090^Đ¹Æ¯fLà´GC²\u0091dt\u0098\u00adĀRt¼¤ĦOðğfÔðDŨŁĞƘï\u009ePÈ\u0086®âbMüÀXZ ¸£@Å\u009a\u009b»»QÉ\u00ad\u0099]d\u0093sÖ×_Í\u0096_ÌêŮPrĔĐÕGĂeZÜîĘqBhtO ¤tE[h|Y\u008bÔ\u0082ZśÎs´xº±U\u008c\u0092ñ\u0088t|O\u0092ĩĠºNbgþ\u008aJy^dÂY Į\u0084]Řz¦gC\u0082³\u0080R`Ā\u008az\u0092¢Aj\u008c¸CL\u0084¤RÆ»@\u00adŎk\\Ç´\u007f£YW}z@Z}\u0089Ã¶\u0093oû¶]´^N\u0087Ò}èN\u0082ª\u0096P\u0098Íy¹`S°´\u0086ATe\u0080VamdUĐwʄvĮÕ\\\u0083u\u008bÆŗ¨Yp¹àZÂm\u0099Wh{á\u0084}WØǍ\u0095Éüw\u0099ga§áCNęÎ[ĀÕĪgÖÉªX\u0098\u008døx¬½Ů¦¦[\u0080\u0097\u0084NÎ\u0086L\u0080ÜUÖ´òrÙŠxR^\u0096\u0086J\u0098k\u0084ĳnDX{U\u0083~ET{ļº¦PZc\u0094jF²Ė@\u008ep\u0098g\u0080\u0088¨\u0093B{\u0083u¨\u009dŦyhoÚD®¯¢\u0098 Wò\u0090àFÎ¤¨GD\u008fäz¦kŮP\u009cġqË\u009a¥À]\u0080\u009f\u0098e\u008eâÚ´ªKxī\u0084P\u0088\u0097Ö|æ[xÃ¤JÞĥ\u0082s\u0092NÖ½\u009e\u0080I\u0086¬nĨY´®Ð\u0097Ɛ\u008a\u0080mD\u0099ŝuäđđEb\u0081\u0085e\u0092\u0081e_\u0099v¡}ìęǊē}q\u0094Éå\u009f\u0081T¯µRs¡M@}ůa\u0086\u008fa\u00ad¯wv\u009dƉåZw\u009e\\Z{åû^\u009b"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            108815,
                            30935
                        ]
                    ],
                    [
                        [
                            110617,
                            31811
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    104.065735,
                    30.659462
                ],
                "name": "四川",
                "childNum": 2
            }
        },
        {
            "id": "520000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@\u0086G\\\u0086lY£\u0091in"
                    ],
                    [
                        "@@q\u0082|\u0088\u0082mc¯tÏ\u0087VSÎ"
                    ],
                    [
                        "@@hÑ£Is\u0087\u007fNg\u0081ßH\u0086\u009b\u0090Hªķ\u009dÃh_¹\u0083¡ĝÄ§ń¦uÙ\u008aù\u008egS\u007f¯JH\u009f|sÝÅt\u008dÁïyMDč»eÕtA¤{b\\}\u0097\u0083G®u\\\u008f\u0081åPFq\u008bwÅaD\u0085\u009eK°ºâ_£ùbµ\u0094mÁ\u008bÛ\u009cĹM[q\u0081|hlaªāI}Ñ\u0082\u0083µ@swtwm^oµ\u0088\u007fDéĽŠyV\u0099ky°É\u009eûÛR\u0085³\u0082\u0087e\u0088\u0087¥]RÕ\u008běħ[ƅåÛDp\u008c\u0081\u0094J\u0084iV\u0099\u0099\u0089ÂF²\u0081I\u0085»mN·£\u009bLbÒYb\u0097WsÀb\u008e\u0099pki\u0099TZĄă¶H\u008cq`\u0085\u0085ĥ_J\u009f¯ae«\u0083KpÝx]aĕÛP\u0083Çȟ[ÁåŵÏő\u0097÷Pw}\u0087T\u009cÙ@Õs«ĿÛq©½\u009cm¤ÙH·yǥĘĉBµĨÕnđ]K\u0084©\u0084œá\u008b\u009fGçş\u008d§Õßg\u0087\u008dǗĦTèƤƺ{¶ÉHÎd¾ŚÊ·OÐjXWrãLyzÉAL¾ę¢bĶėy_qMĔąro¼hĊ\u009ew¶øV¤w\u0094²Ĉ]Ê\u009aKx|`ź¦ÂÈdr\u0084cÈ\u0081be¸\u009b`I¼čTF´\u009d¼Óýȃr¹ÍJ©k_șl³´_\u0090pĐ\u009d`oÒh\u008e¶pa\u0082^\u0090ÓĔ}D»\u009d^Xy\u009c`d\u0098[Kv\u0085JPhèhCrĂĚÂ^Êƌ w\u0088ZL\u00adĠ£\u009aÁbrzOIl\u0092MM\u0094ĪŐžËr×ÎeŦ\u008etw|\u008c¢mK\u0081jSǘňĂSt\u008dÎŦEtqFT\u0086¾\u0086Eì¬¬ôxÌO¢\u009f K\u008a³ŀºäY\u0086\u0084\u0094PVgŎ¦ŊmŞ¼VZwVl\u008c\u008d\u0084z¤\u0085\u009e£Tl®ctĽÚó{G\u007f\u00adA\u0087\u008cÇge\u009a~Î\u0091d¿æaSba¥KK\u007fû\u0090j®_Ä\u0087^\\Ø¾bP®¦x^sxjĶI_Ä X\u0082â¼\u0095Hu¨Qh¡À@\u0090Ëô}\u008e±\u009eGNìĎ\u007flT\u007f¸\u0088\u0085`V\u007f~R°tbÕĊ`¸úÛtÏ\u0080FDu\u0080[\u0083Mf\u0081qGH·¥yA\u0089zt\u0090MFe|R\u0082_Gk\u0086ChZeÚ°to\u0098v`x\u008bb\u0084\u008cDnÐ{E}\u009aZ\u0098è\u0080x\u0097\u0086NEÞ\u008aREn\u0098[Pv@{~rĆAB§\u0082EO¿|UZ~ì\u0084Uf¨J²ĂÝÆ\u0080\u0082sª\u0096B`\u0084s¶\u009cfv\u0081ö¦\u008aÕ~dÔq¨¸º»uù\u0090[[§´sb¤¢zþF\u009c¢Æ\u0085Àh\u0088\u0099\u0090Â\u0088W\\ı\u008eËIÝ\u008ao±ĭŠ£þ\u0088Ês}¡R\u009d\u008f]\u008cě\u0083\u007fD\u009d\u0082g´VG¢\u0082j±®è\u0086ºÃm\u008dpU[Á\u009b\u0091\u008cëº°r\u009bÜbNu¸}\u008eº¼\u0087`ni\u0094ºÔXĄ¤¼Ôdaµ\u0080Á_Ã\u0080\u0085\u0086ftQQg\u009cR\u0097\u0091·Ǔ\u0092v\u0094}Ý×\u009cĵ]µ\u009c\u0093Wc¤F²\u009bOĩųãW½¯K\u008d\u0082©\u0085]\u0080\u0081{\u0086L\u008fóµCIµ±Mß¿h\u009f\u0095©āq¬o\u0082½\u009e~@i~TUxŪÒ¢@\u0083£ÀEîôruń\u0082\u0094\u0093\u0082b[§nWuMÆLl¿]\u0081x}ĳ\u00ad\u0080½"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            112158,
                            27383
                        ]
                    ],
                    [
                        [
                            112105,
                            27474
                        ]
                    ],
                    [
                        [
                            112095,
                            27476
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    106.713478,
                    26.578343
                ],
                "name": "贵州",
                "childNum": 3
            }
        },
        {
            "id": "530000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u008d\u0081[\u0084ùx½}ÑRH\u0091\u0081Yīĺû\u007fsÍn\u0091iEoã½Ya\u0081²ė{c¬ĝg\u0095ĂsA\u0095ØÅwď\u0082õzFjw}\u0097«Dx¿\u0081}Uũl\u009fê\u0099@\u0095\u008fH\u008fÅ\u00adF\u0089¨ÇoJ´Ónũuą¡Ã¢pÒÅ\u008c\u0093Ø TF²\u0082xa²ËX\u0080\u0082cÊ\u008blHî\u007fAßËŁkŻƑŷÉ©h\u0099W\u00adæßU\u0087\u0093Ës¡¦\u007f}\u0095teèÆ¶StÇ\u0080Ç}Fd£j\u008bĈZĆ\u0090Æ\u008b¤T\u0082č\\D\u0083}O÷\u009a£\u0081U\u0088§~ŃG\u0099\u0082å\u0081ŃDĝ¸\u009cTsd¶¶Bª\u009a¤u¢ŌĎo~t¾ÍŶÒtD¦Ú\u0084iôö\u0089\u0080z\u009bØX²ghįh½\u0090Û±¯\u0080ÿm·zR¦Ɵ`ªŊÃh¢rOÔ\u008d´£Ym¼èê\u008df¯ŪĽn\u0084\u0086cÚb\u008cw\\zlvW\u009eªâ\u0088 ¦g\u0096\u008fmĿBĹ\u009f£¢ƹ\u007fřbĥkǫßeeZkÙIKueT\u0081\u009d»sVesb\u0091\u008da\u0090ĕ  ¶®dN\u009cĄÄpªy\u008e\u0090¼\u0097\u0084³BE\u0098®l\u0087\u008eG\u009cŭC\u009cǶwêżĔÂe\u0084pÍÀQƞpC\u0084\u0096¼ŲÈ\u00ad\u0090AÎô¶R\u0084ä\u0092Q^Øu¬°\u009a_Èôc´¹ò¨PÎ¢hlĎ¦´Ħ\u0093Æ´sâÇ\u0084\u008fŲPnÊD^¯°\u0092Upv\u0086}®\u0081BPÌª\u0096jǬx\u0096Söwlfò\u007fªv\u0080qĸ|`H\u0080\u00adviļ\u0080ndĜ\u00adĆhň\u0095\u0082em·FyÞ\u0081qó\u009eSį¯\u0091³X_ĞçêtryvL¤§z\u0084¦c¦¥jnŞk\u0098\u0088lD¤øz½Ĝà\u009eĂŧMÅ|áƆàÊcðÂFÜ\u008e\u0082áŢ¥\\\\º\u0099İøÒ\u007fÐJĴ\u0087\u0084îD¦\u0090zK²ǏÎEh~\u0092CD\u0090\u00adhMn^ÌöÄ©ČZÀ\u009eaü\u0084fɭyœpį´ěFűk]Ôě¢qlÅĆÙa¶~Äq\u009a\u009aê\u007f\u0080lj\u007f\u0090N¬¼H\u0084Ê\u009aNQ´ê¼VØ¸E\u0086\u0086^ŃÒy\u008c\u0083M{\u008cJLoÒ\u007f\u009cęæ\u009fe±Ķ\u009by\u0089\u0092\u0087g\u0081ã\u0093¯JY\u008dÆĭĘëo¥Š\u0089o¯hcK«z_p\u008arC´ĢÖY\u0094\u0097¼ v¸¢R\u008eÅW³Â§fÇ¸Yi³xR´ďUË\u008a`êĿU\u007f\u0084û\u0080uĆB\u0083ƣö\u0089N\u0081\u0080DH«Ĉg\u0086\u0097\u0097Ñ\u0082aB{ÊNF´¬c·Åv}eÇÃGB»\u0094If\u0095¦HňĕM\u0085~[iwjUÁKE\u0095\u008e\u008b¾dĪçW\u009b\u009a\u0081I\u008bèÀ\u008coÈXòyŞŮÈXâÎŚ\u008aj|àsRy\u008bµÖ\u009b\u0096Pr´þ\u008c ¸^wþTDŔ\u0096Hr¸\u008b\u009eRÌmf\u0087żÕâCôox\u0096Ĝ\u007fƌÆĮ\u008c\u009bÐ\u0096\u009cY\u0098tâŦÔ@]ÈǮƒ\\Ī¼Ä£UsÈ¯LbîƲŚºyh\u0087r\u008c\u008a@ĒÔ\u009dƀ\u009fÀ²º\\êp\u0093\u0092J\u008a}Ġv\u008aqt\u0084Ġ@^xÀ£È\u0086¨mËÏğ}n¹_¿¢×Y_æp\u0088Å\u0096A^{½\u0095Lu¨GO±Õ½ßM¶w\u0092ÁĢÛ\u0082P\u0082\u009bƢ¼pcĲx\u008a|apÌ¬H\u009aÐ\u008cŊ\u007fS\u009dfsðBZ¿©\u0093XÏÒK\u0095k\u0086÷Eû¿\u0089S\u0085rEFsÕūk\u0094óVǥŉiTL\u0082¡n{\u008buxţ\u008dÏh\u0099ôŝ¬ğōN\u0093\u0091NJkyPaq\u0099Âğ¤K®\u0087Y\u009fxÉƋÁ]āęDqçgOg\u0086ILu\u0097\\_gz\u0097]W¼\u009e~CÔē]\u008fb\u0081µog\u008dpÑ\u009e_oď`\u008f´³Țkl`IªºÎȄqÔþ\u009e»E³ĎSJ»\u009c_f·\u0082adÇq\u0083Çc¥Á_Źw{\u0099L^É±ćx\u0093U£µ÷\u009dxgĉp»ĆqNē`rĘzaĵĚ¡K½ÊBzyäKXqiWPÏÉ¸½řÍcÊG|µƕƣGË\u009b÷\u009fk°_^ý|_zċ\u0090BZocmø¯hhcæ\\l\u0088MFlư£Ĝ\u0084ÆyH\u0093\u0084F¨\u008d\u0089µêÕ]\u0097\u009bHA\u0085àÓ\u0084^it `þßäk\u008aĤÎT~Wlÿ¨\u0084ÔPzUC\u008f\u0096NVv [jâôDôď[}\u009e\u0089z¿\u0096msSh\u008b¯{jï\u008dğl}šĹ[\u0096ő\u008c\u0089gK\u008b©U·µË@¾\u0083m_~q¡f¹\u0085ÅË^»\u0091f³ø}Q\u0095\u0084¡ÖË³gÍ±^Ç\u0081\u0085\\ëÃ\u0083A_\u0097¿bW\u009bÏ[¶ƛé\u008f\u009d£F{īZgm@|kHǭƁć¦UĔť\u0083×ë}ǝ\u0083eďºȡȘÏíBÉ\u0099£āĘPªĳ¶\u0093ŉÿ\u0087y©n\u0089ď£G¹¡I\u009b\u008a±LÉĺÑdĉÜ\u0087W¥\u0098\u0089}g\u0098Á\u0086{aqÃ¥a\u008a\u009dıę\u009dÏZ\u0097ï`"
                ],
                "encodeOffsets": [
                    [
                        104636,
                        22969
                    ]
                ]
            },
            "properties": {
                "cp": [
                    101.512251,
                    24.740609
                ],
                "name": "云南",
                "childNum": 1
            }
        },
        {
            "id": "540000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@Â\u009dh\u009eľx\u008e\u009dŖ\u0089x\u0083ÒV\u008e\u0086ºÅâAĪÝȆµę¯Ňa±r_w~uSÕň\u0091qOj]ɄQ\u0085£Z\u0085\u0085UDûoY\u0092»©M[\u008bL\u008d¼qãË{VÍ\u0095çWV\u008fi\u008f\u008e]ë©Ä÷ày\u0081ƛh\u009bÚU°\u008c\u008ca\u0094d\u0084cQ\u0083~Mx¥\u0099cc¡ÙaSyF\u0097Ö\u0081k\u00ad\u008cuRýq¿Ôµ\u009d\u0095QĽ³aG{¿FµëªéĜÿª@¬·\u0096K\u0089·àar\u008diĕĀ«V»Ŷ\u0099Ĵū\u0098gèLǴŇƶaf\u008bt\u008cèBŚ£^\u008aâ\u0086ǐÝ®\u0096\u009aM¦ÁǞÿ¬Lh\u009f\u008eJ¾óƾÆºcxw\u008d\u008bf]Y\u0085´\u0083¦|\u009cQLn°a\u009cdĊ\u0085\u009c\\¨o\u0092\u009cǀÍŎ\u009c´ĩĀd`tÊQŞŕ|\u0082¨C^©\u009c\u007fĈ¦\u0084¦ÎJĊ{\u008eëĎjª\u008f²rÐ\u0089\u009al`¼Ą[t|¦Stè¾\u0089P\u008cÜK¸\u0080d\u0098Ƅı]s¤\u0097î_v¹ÎVò\u009dŦj\u0098£Əsc\u0097¬_Ğ´|Ł\u0098\u009d¦Av\u008e¦w`ă\u008fa\u0090\u008dÝaa\u00ad¢e¤ı²©ªSª\u009aÈMĄw\u009eÉØŔì@T\u0091¤\u0097Ę\u0099\\õª@\u0094þo´\u00adxA \u0090\u0090s\u0094ÂtŎKzó´ÇĊµ¢r\u009e\u007f^nĊ\u00adÆ¬×üG\u009e¢\u0082³ {âĊ]\u009a\u0099G\u0082~bÀgVj\u0081zlhǶ\u008df\u0080\u009eO\u0081\u009afd\u008a\u0089ªB]pj\u0084\u0095TO\u0096tĊ\u0082n¤}®¦\u0083Č¥d¢¼»dd\u009a\u0094Y¼\u008et\u0097¢eȤJ¤}Ǿ¡°§¤AÐ\u0093lc@ĝ\u0094sªćļđAç\u0087wx\u0095UuzEÖġ~AN¹ÄÅȀŻ¦¿ģŁéì±H\u0085ãd«g[Ø\u0089¼ēÀ\u0095cīľġ¬cJ\u0091µ\u0085ÐʥVȝ¸ßS¹\u0086ý±ğkƁ¼ą^ɛ¤Ûÿ\u0089\u009db[}¬ōõÃ]ËNm®g@\u008d\u0095Bg}ÍF±ǐyL¥\u008fíC\u0088\u0083Iĳ\u0080Ï÷Ñ\u009aį[¹¦[âš\u008d\u0081EÛïÁÉdƅß{âNÆāŨß\u009d¾ě÷yC£\u0087k\u00ad´ÓH@Â¹\u0086TZ¥¢į\u0083·ÌAÐ§®\u0097Z\u008fc\u0085v½\u009fZ\u00ad\u008d¹|Å\u0095WZqgW\u0093|ieZ\u007fÅYVÓ\u0081qdq\u008f\u0095bc²R@\u0081\u0086c\u0087¥Rã»Ge\u0086\u009feƃīQ\u0095}J[Ò\u0093K\u0085¬Ə|o\u0092ėjġĠÑN¡ð¯EB\u007fčnwôɍ\u008fėª\u0083²\u0095CλŹġǝʅįĭạ̃ūȹ]ΓͧgšsgȽóϧµǛ\u0086ęgſ¶ҍć`ĘąŌJÞ\u009aä¤rÅň¥ÖÁUětęuůÞiĊÄÀ\\Æs¦ÓRb|Â^řÌkÄŷ¶½÷\u0087f±iMÝ\u0091\u009b\u0089@ĥ°G¬ÃM¥n£Øą\u0082ğ¯ß\u0094§aëbéüÑOč\u009ck£{\\\u0091eµª×M\u0091\u009aÉfm«Ƒ{Å×\u0083Gŏǩãy³©WÑăû\u0082··\u0091Q\u0097òı}¯ã\u0089I\u0095é\u007fÕÂZ¨īès¶ZÈs\u008eæĔTŘv\u008egÌsN@îá¾ó@\u0089\u0098ÙwU±ÉTå»£Tđ\u009fWx\u008fq¹Zo\u0091b\u008bs[×\u008c¯cĩv\u0087\u008cėŧ³BM|¹k\u0089ªħ\u0097¥TzNYnÝ\u008dßp\u008d\u0081ęrñĠĉRS~½\u008aěVV\u008aµ\u0082õ\u0087«\u008cM££µB\u0095ĉ¥áºae\u0081~³AuĐh`\u008fÜ³ç\u009d@BÛ\u0098ïĿa©|z²Ý¼D\u0094£àč²\u008bŸ\u0083I\u0083û\u009b\u0081I ā\u0080óK\u008d¥}rÝ_Á´éMaň¨\u0080~ªSĈ½\u008e½KÙóĿeƃÆB\u008e·¬ën×W\u008d|Uº}LJrƳ\u0098lŒµ`bÔ\u007f`Q\u0088\u0088ÐÓ@s¬ñI\u007f\u008cÍ@ûws¡åQÑßÁ`ŋĴ{Ī\u0093T\u0095ÚÅTSÄ³\u0082\u008bYo|Ç[Ç¾µMW¢ĭiÕØ¿@\u0098\u009aMh\u0085pÕ]j\u0086éò¿OƇĆƇp\u0080êĉâlØw\u0096ěs\u008f\u0088ǩ\u0082ĵ¸c\u0085\u009dbU¹ř¨WavquSM\u009dzeo_^gsÏ·¥Ó@~¯\u009d¿RiīB\u0099\u008a\\\u0094qTGªÇĜçPo\u008aÿfñòą¦óQīÈáP\u0095\u009cābß{\u0083ZŗĸIæÅ\u0084hnszÁCËìñ\u009aÏ·ąĚÝUm®ó\u00adL·ăU\u009bÈíoù´\u0081Êj°ŁŤ_uµ^\u0091°\u008cìÇ\u0096@tĶĒ¡Æ\u0087M³Ģ«\u0098İĨÅ®ğ\u0086R\u008eāð\u0093ggheÆ¢z\u0082Ê©Ô\\°ÝĎz~ź¤Pn\u0096MĪÖB£\u0090\u009fk\u0099né\u0084§żć\u008a\u0098ĆK\u0084Ē°\u0090¼L¶è\u0089âz¨u¦¥LDĘz¬ýÎmĘd¾ß\u0094Fz\u0093hg²\u0099Fy¦ĝ¤ċņbÎ\u009b@y\u0082Ąæm°NĮ\u0081ZRÖí\u008eJ²öLĸÒ¨Y®ƌÐV\u0089à\u0098tt_Ú\u0080ÂyĠz\u009e]Ţh\u0080zĎ{Â\u0086ĢX\u0094\u0088c|\u009aÐq\u008e\u009afO¢¤ög\u0082ÌHN\u008e\u0084PKŖ\u009c\u008e\u0098Uú´xx[x\u0088vĐCûĀ\u008aìÖT¬¸^}Ìsòd´_\u008e\u0087KgžLĴ\u0085ÀBon|H@\u0096Êx\u0098\u0097¦Bp\u009dŰ\u0088Ō¿fµƌA¾zǈRx\u008a¶F\u0094\u009ckĄź\u0090Rzŀ\u0088~¶[\u0094´Hnª\u0096VƞuĒ\u00adÈ¨Ǝc\u0090ƽÌm¸ÁÈM¦x͊ëÀxǆB\u0092\u009aú^´W\u0086£\u0096d\u0084kɾĬp\u009cw\u0082˂ØɦļĬIŚ\u009cÊ\u0095n\u009bŔa¸\u0099~J°î\u0094lɌxĤÊÈðhÌ®\u0082g\u0098T´ø\u008eàC\u0088\u008eÀ^ªerrƘd\u009e¢İP|\u008dĖ ŸW\u009cªĦ^¶´ÂL\u0084aT±üWƜ\u0098ǀRÂ\u009aŶUń\u009aĖ[QhlLüA\u0086\u008bÜ\\\u0086qR\u009bĄ©"
                ],
                "encodeOffsets": [
                    [
                        90849,
                        37210
                    ]
                ]
            },
            "properties": {
                "cp": [
                    89.132212,
                    30.860361
                ],
                "name": "西藏",
                "childNum": 1
            }
        },
        {
            "id": "610000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@\u0098p¢\u0097Ȯµ\u009aûG\u0099Ħ}Ħ\u009að\u0081ǚ¶ò\u008fƄ\u0080jɂz°{ºØkÈęâ¦jª\u0082Bg\u0082\\\u009cċ°s¬\u008e\u0092]j\u009eú \u0082E\u0094Ȍǆ¬s\u0084t\u0087\u0094R\u0088ÆdĠİ\u008ewÜ\u0094¸ôW¾ƮłÒ_{\u0092Ì\u009aû¼\u0084jº¹¢GǪÒ¯Ę\u0083Z`ºŊ\u0083ecņą\u009a~B\u0090ÂgzpâēòYǠȰÌTÎ¨ÂW\u009c|fc\u009fă§uF\u0097\u008c@N\u009f¢XL\u0083\u008aRM\u007fº[ğȣſï|¥J\u0099kc`sŉǷ\u0092\u009dY¹\u008bW@µ÷K\u0085ãï³ÛIcñ·\u0081VȋÚ\u008dÒķø\u009d©\u0097þ¥\u0083y\u0082Ó\u009fğęmWµÎum\u007fZy\u0081OŅƟĥÓ~sÑL¤µaÅ\u0085Y¦ocyZ{\u0089y c]{\u008cTa©\u0083`U_Ěē£ωÊƍKù\u0092K¶ȱÝƷ§{\u007fû»ÅÁȹÍéuĳ|¹cÑd\u0091\u008a\u007fìUY\u0083\u008eO\u0091uF\u008d\u0096ÕÈYvÁCqÓ\u0083T\u0095Ǣí§·S¹Ng\u008aV¬ë÷Át\u0087°DØ¯\u0092C´ŉƒópģ}\u007f\u0084ċ\u0081cEË\u0085F\u009f\u009féGU¥×K\u0085§\u00ad¶³B\u008bČ}C¿åċ`\u008dwġB·¤őcƭ²ő[Å^axwQO\u0085ÿEËßŚ\u0095ĤNĔ\u009fwƇ\u0088\u0081Ä\u008ańwĪ\u00ad\u008ao[\u007f\u0084_KÓª³\u0093\u008fÙnK\u0089Ç\u0083ě\u009cÿ]ď\u0080ă_d©·\u007f©Ý\u007fŏ°Ù®g]±\u0084\u009f\u0087ß\u0098å\u009b\u0097¬÷\u009dm\\\u009biaǑkěX{¢|ZKlçhLt\u0081\u0080Ňîŵ\u0080œè[\u0080É@ƉĄE\u009c\u0087tƇ\u008fÏ\u0098³\u00adħZ«mJ\u0085\u009b\u007f×¾\u0091M\u0081tÝĦ£IwÄå\\Õ{\u0087\u0098\u0083OwĬ©LÙ³\u0081ÙgBƕŀrÌ\u009bĢŭO¥lãyC\u0090§HÍ£ßEñ\u008f\u009fX¡\u0097\u00ad°ÙCgpťz\u0091\u0088b`wI\u0084vA|§\u0094\u007f\u0087\u0097h\u008doĕ@E±\u0093iYd¥OĻ¹S|}F@¾oAO²{tf\u009eÜ\u0097¢FǂÒ\u0088W²°BĤh^Wx{@\u0084¬\u0082\u00adF¸¡\u0084ķn£\u0090P|\u009fªĴ@^ĠĈæb\u0096Ôc¶l\u0098Yi\u0085\u0096^Mi\u0098cĎ°Â[ä\u0080vï¶gv@\u0090À\u0093Ĭ·lJ¸sn|¼u~\u008da]\u0092ÆÈtŌºJp\u0092\u0083þ£KKf~\u008a¦UbyäI\u009aĺãn\u0087Ô¿^\u00ad\u009eŵMT\u0096\u007fhĠÜ¤ko¼Ŏìąǜh`[t\u008cRd²Ĳ_\u009cXPrɲ\u0089l\u0091\u0082X\u009eiL§à\u0083\u0096¹\u008eH\u0098°Ȧq\u0090º®QC\u0097bA\u0086\u0084ŌJ¸\u0090ĕÚ³ĺ§ `d¨Yj\u009eiZvRĺ±öVKkjGȊÄ\u0090eP\u007fĞ\u009eZmļKÀ\u0080\u0082[\u008a\u008e`ösìh\u0086ïÎoĬdtKÞ{¬èÒÒB\u008cÔpĲÇĬJŊ\u0081¦±J«\u0088Y§\u008b@·pH\u0080µàåVKe\u009bpW\u0086ftsA\u0081ÅqC·¬ko«pHÆuK@o\u009fH\u0081ĆÛ\u0084ķh\u008dx\u0093e\u0091n\u009bS³àǍrqƶRbzy\u0080¸ËÐ\u0090l\u009b¼EºpĤ¼\u008cx¼½~Ğ\u0092\u0081\u0094à@\u0086ÚüdK^\u0088m\u0090ÌSj"
                ],
                "encodeOffsets": [
                    [
                        110234,
                        38774
                    ]
                ]
            },
            "properties": {
                "cp": [
                    108.948024,
                    34.263161
                ],
                "name": "陕西",
                "childNum": 1
            }
        },
        {
            "id": "620000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@VuUv"
                    ],
                    [
                        "@@ũ\u008bE\u008dĠtt~nkh`Q\u0089¦ÅÄÜdw\u0098Ab×ĠąJ\u0088¤DüègĺqBq\u009cj°lI¡ĨÒ¤úSHb\u009a\u0087\u008ajÎ\u0091B\u008a°aZ\u0088¢KJ\u008e\u0092O[\u0090|A£\u009eDx}NĂ¬\u0095HUnrk\u0084 kp\u0080¼Y kMJn[aG\u0082áÚÏ[½rc\u0086}aQxOgsPMnUs\u0087nc\u008f\u008bZ\u0085\u009e\u0096sKúvA\u009bt\u0084Þġ\u0092£®ĀYKdnFw\u009a¢JE°\u0094Latf`¼h¬we|\u0080Æ\u0087\u009abj}GA\u0080·~W\u008e\u0094\u0097`\u0086¢MC¤tL©Ĳ°qdf\u0094O\u0082\u0093bÞĬ¹ttu`^Zú\u009dE`\u008c[@\u0084Æsîz®¡\u0092C\u0084ƳƜG²\u0093R\u0091¢R\u0092m\u0094f\u008ewĸgÜ\u0083\u0082ą G@pzJM½\u0090m\u008ahVy¸uÈÔO±¨{LfæU¶ßG\u007fĂq\\ª¬\u0087²I\u0082¥IŉÈīoı\u008bÓÑAçÑ|«LÝcspīðÍg\u0085të_õ\u0089\u008d\u0081\\ĉ\u007fñLYnĝ\u009dg\u0092\u009fRǡÁiHLlõUĹ²uQjYi\u009d§Z_c¨\u009f´ĹĖÙ·\u008fŋI\u0085\u0083aBD\u0098\u00adR\u008f¹ȥr\u0097¯\u008dG\u0095ºß\u0084K¨\u009dj\u0081Wk\u0092ɱ\u008aOq\u009bWĳ\\a\u00ad\u008bQ\\sg_ĆǛōëp»£lğÛ\u0080gS\u0095ŶN®\u009dÀ]\u0088Óäm\u0099ĹãJaz¥V}\u0089Le¤L\u0084ýo\u0091¹IsŋÅÇ^\u0091\u008ebz\u0085\u007f³tmEÁ´a\u008a¹cčecÇN\u0095Ċã\u007fÁ\\č¯\u0097dNj\u0095]j\u0086\u0097ZµkÓda\u0095ćå]ğĳ@ ©O{¤\u008fĸm¢\u0083E·\u0081®\u0083«|@Xwg]Aģ±¯\u0087XǁÑǳªc\u009bwQÚŝñsÕ³ÛV_\u008fý\u0083\u007f\u0098¥\\ů¥©¾÷w\u0097\u008e©WÕÊĩhÿÖÁRo¸V¬âDb¨\u009ahûx\u0096Ê×ǌ~Zâ\u0083g|\u009aXÁnßYoº§ZÅŘv\u008c[\u0084ĭÖʃuďxcVbn\u007fUSf\u0085B¯³_Tzº\u0097Î\u0095O\u0081©çMÑ~M\u0088³]µ^püµ\u0094\u008aÄY~y@X~¤Z³\u0080[Èōl@®Å¼£QK\u0083·Di\u008b¡By\u0091ÿ\u0089Q_´\u007fD\u0081¥hŗy\u0083^\u009fĭÁZ]cIzý\u0089ah¹MĪğP\u0091s{ò\u0087\u008b\u0091²Vw¹t³ŜË\u0081[\u008eÑ}X\\gsF\u009f£sPAgěp×ëfYHāďÖqēŭOÏë\u0093dLü\u0095\\i\u008c\u0094t^c®\u009aRÊº¶\u0097¢H°m\u0088\u0091rY\u009f£B\u009f¹čIoľu¶uI]vģSQ{\u0083UŻ\u0094Å}QÂ|Ì\u008b°ƅ¤ĩŪU ęĄ\u009eÌZÒ\u009e\\v\u0098²PĔ»ƢNH\u0083ĂyAmƂwVm\u009e`\u0094]È\u008fb\u0095\u0094H`\u0089Ì¢²ILvĜ\u0097H®¤Dlt_\u0084¢JJÄäm\u0090èÔDëþgºƫ\u0090\u0099\u0094aʎÌrêYi~ Îİ¤NpÀA¾Ĕ¼b\u0085ð÷\u0092\u008e\u0088\u0087®\u0082\u0094üs\u0094zMzÖĖQdȨý\u0086v§Tè|\u009dªH\u0092Ã¾a¸|\u009aÐ ƒwKĢx¦ivr^ÿ ¸l öæfƟĴ·PJv}n\\h¹¶v\u0086·À|\\ƁĚN´Ĝ\u0080çèÁz]\u0090ġ¤²¨QÒŨTIl\u0087ªťØ}¼˗ƦvÄùØEÂ\u008b\u0092«FïË\u009bIq\u0094ō\u008cTvāÜŏ\u0082íÛß\u009cÛV\u0097j³âwGăÂíNO\u008a\u0088\u008aPìyV³\u007fŉĖýZso§HÑ\u0096\u008diY\u0090w[ß\u0086\\X\u007f¦¥c]ÔƩÜ·«j\u0087ÐqvÁ¦m^ċ±R\u0099¦΋ƈťĚgÀ»IïĨʗƮ\u008e°Ɲ\u0098ĻþÍAƉſ±tÍEÕÞāNUÍ\u0097¡\\\u0081ſčåÒʻĘm ƭÌŹöʥ\u0092ëQ¤µ\u00adÇcƕªoIý\u0088\u0089IÉ\u0090_mkl³ă\u0089Ɠ¦j\u0097¡Yz\u0095Ňi\u0096}Msßõ\u0096īʋ \u0097}\u0083ÁVm\u009f_[n}eı\u0090\u00adUĥ¼\u0091ª\u0095I{Î§DÓ\u009cƻėoj\u0091qYhĹT©oūĶ£]ďxĩ\u008bǑMĝ\u0089q`B´ƃ˺Ч\u0097ç~\u0099²ņj@\u0094¥@đ´ί}ĥtPńÇ¾V¬ufÓ\u0083ÉC\u008btÓ\u007f̻\u0089\u0085¹£G³\u0080]ƖƾŎĪŪĘ̖¨ʈĢƂlɘ۪üºňUðǜȢƢż̌ȦǼ\u0082ĤŊɲĖÂ\u00adKq´ï¦\u0097ºĒǲņɾªǀÞĈĂD\u0086½ĄĎÌŗĞrôñn\u008e\u009cN¼â¾ʄľԆ|Ǆ\u008e֦ज़ȗǉ̘̭ɺƅêgV̍ʆĠ·ÌĊv|ýĖÕWĊǎÞ´õ¼cÒÒBĢ͢UĜð͒s¨\u0081ňƃLĉÕÝ@ɛƯ÷¿Ľ\u00ad\u008dĹeȏĳëCȚDŲyê×Ŗyò¯ļcÂßY\u0085tÁƤyAã˾J@ǝrý\u008b\u0089@\u008f¤\u0085rz¸oP¹ɐÚyá\u0090\u0087H\u009fĀ[Jw\u0085cVeȴÏ\u009c»È\u008eĖ}ƒŰŐèȭǢόĀƪÈŶë;Ñ̆ȤМľĮEŔ\u008d\u0097ĹŊũ~ËUă{\u009fĻ\u009dƹɁύȩþĽvĽƓÉ@ē\u0084ĽɲßǐƫʾǗĒpäWÐxnsÀ^ƆwW©¦cÅ¡\u0081Ji§v\u008fúF¶\u008e¨c~c¼ī\u008ceX\u009dǚ\u008b\\đ¾J\u008ewÀďksãA\u008d\u008bfÕ¦\u008dL}wa\u0082o\u0094Z\u0092\u008bD½\u0086Ml«]eÒÅaÉ²áo\u009d½FõÛ]ĻÒ¡wYR£¢rvÓ®y®LF\u008bLzĈ\u0084ôe]\u0081gx}\u0095|KK}xklL]c¦£fRtív¦\u0086PĤoH{tK"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            108619,
                            36299
                        ]
                    ],
                    [
                        [
                            108589,
                            36341
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    103.823557,
                    36.058039
                ],
                "name": "甘肃",
                "childNum": 2
            }
        },
        {
            "id": "630000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@InJm"
                    ],
                    [
                        "@@C\u0083Æ½OŃĦsΰ~Ē³¦@@\u0093Ņi\u009a±è}Ш\u0098Ƅ˹A³r_Ğ\u008aǒNĪ\u008cĐw¤^ŬĵªpĺSZg\u0092rpiƼĘÔ\u009b¨C|Í\u0096J\u0092©Ħ»®VĲ\u008f~f\\m `Un\u0084Â\u0098~ʌ\u009f\u0095ĬàöNt\u0095~ňjy\u0096¢Zi\u0098Ɣ¥Ą\u008ak´nl\u008f`JÊ\u0087\u008aJþ©pdƖ®È£¶ìRʦ\u0091źõƮËn\u009fʼėæÑƀĎ[\u0082\u0098¢VÎĂMÖÝÎF²sƊƀÎBļýƞ\u0097\u008d¯ʘƭðħ¼Jh¿ŦęΌƇ\u009a¥²Q]Č¥nuÂÏri\u0088¸¬ƪÛ^Ó¦d\u0080¥[Wà\u0085x\\Z\u008f\u008ejÒ\u0095¨GtpþYŊĕ´\u0080zUOë\u0087\u0089P\u0089îMĄÁxH´á\u0098iÜUà\u009bîÜŐ\u0081ĂÛSuŎ\u008br\u0093\u009cJðÌ¬E\u008c\u0091FÁú×uÃÎkr\u0093Ē{V}İ«O_ÌËĬ©\u008eÓŧSRÑ±§Ģ£^\u008fÂyèçě\u007fM³Ƃę{[¸¿u\u0085ºµ[gt£¸OƤĿéY\u009fõ·kĀ\u009fq]juw¥Dĩƍ\u0080õÇPéÄ½G\u0091\u009e©ã\u0087¤G\u0085uȧþRcÕĕNy\u0093yût\u0081\u0093\u0088\u00ad\u008d\u0087ø\u0091\u0086ï»a½ē¿BMoį£\u009fÍj}éZËqbʍ\u009a\u0093Ƭ\u008fh¹ìÿÓA\u008fçãnIÃ¡I`\u0083ks£CG\u00adě\u0098Uy×Cy\u0095\u0085\u0092\u009f@\u0081¶ʡÊBnāzG\u0084ơMē¼±O÷õJ\u008f\u009dËĚăV\u009fĪũƆ£\u008c¯{ËL½Ìzż\u0093\u0084VR|ĠTbuvJvµhĻĖH\u0094\u0090Aëáa\u0085\u00adOÇð\u009dñęNw\u0087\u0085œľ·L\u009bmI±íĠĩPÉ×®ÿs\u0097\u0092cB³±JKßĊ«`\u0085ađ»·\u008fQAmO\u0092\u0091Vţéÿ¤¹SQt]]Çx\u0080±¯A@ĉĳ¢Óļ©\u0090\u0095\u0083l¶Å\u008dÛr\u0097ŕspãRk~¦ª]Į\u00ad´\u0093FR\u0084åd\u00adČsCqđéFn¿Åƃm\u0092Éx{W©ºƝºįkÕƂƑ¸wWūÐ©ÈF\u009e£\\tÈ¥ÄRÈýÌJ \u0083lGr\u0090^×äù\u0090yÞ³fj\u0094c\u0086\u0080¨£ÂZ|ǓMĝ\u009aÏ@ëÜőR\u008b\u009bĝ\u0089\u008c÷¡{aïȷ\u0081P\u008f\u007fu°ËXÙ{©TmĠ}Y³\u0092\u00adÞIňµç½©C¡į÷¯B»|St»\u009b]v\u0083ų\u0083s»\u0094}MÓ ÿʪƟǭA¡fs\u0098»\u008d\u009dPY\u008f¼c¡»¦c\u0084ċ\u00ad¥£~\u0081msĉP\u0095\u0096Si\u0083^o©A\u0089\u008aec\u0082\u0099\u009dPe\u007fǵ\u008ekg\u0082yUi¿h}aH\u0081\u0099\u009aĉ^|á´\u009f¡\u0081H\u009dØûÅ«ĉ®]m\u009d\u0080¡qĉ¶³ÈyôōLÁst\u0093\u008f\u008fB\u009f®wn±\u009dă¥HSòė\u009a£\u0098S\u0092ë@×œ\u009dÊăxÇN©\u0099©T±ª£Ĳ¡fb®Þb\u008f\u008e\u0090b_Ą¥xu\u008d¥B\u0097\u009e{łĝ³«`d\u0098Ɛt\u0097¤ťiñ\u009eÍUuºí`£\u0098^tƃĲc\u0097·\u007fÛLO\u008b½\u008asç¥Ts{ă\\_»\u0099kÏ\u008a±q©\u0090či\u008dìĉ|ÍI\u0083¥ć¥\u009b\u0080]ª§D{\u0081ŝŖÉR_sÿc³Īō\u009bƿÎ\u0091\u009b§p\u009b[ĉ\u0086\u009bc¯bKm\u009bR¥{³\u0084Z\u0086e^\u008e\u008cwx¹dƽÅ½ô\u008dIg §Mĕ ƹĴ¿\u0097ǣÜÍ\u0083]\u008bÝ\u0096\u0081]snåA{\u008be\u008cƭ`ǻŊĿ\\ĳŬű\u0094YÂÿ¬jĖq\u008eßb\u008a¸\u0095L«¸©@ěĀ©ê¶ìÀEH|´bRľ\u009e\u0096Ó¶rÀQþ\u008bvl®Õ\u0082E\u0098TzÜdb \u0098hw¤{LR\u0084\u0083d\u0093c\u008bb¯\u008bÙVg\u009c\u0082ƜßzÃôì®\u008d^j\u0090U\u0090èXÎ\u0096|UäÌ»rK\u008e\\\u008cªN\u0091¼pZCü\u0086VY\u0086\u0086¤ɃRi^rPŇ\u0092TÖ}|br°qňbĚ°ªiƶGQ¾²\u0084x¦P\u009cmlŜ\u0091[\u0081Ĥ¡ΞsĦ\u009fÔÏâ\\ªÚŒU\\f\u0085¢N²§x|¤§\u0084xĔsZPòʛ²SÐqF`ª\u0084V\u0083ÞŜĶƨVZ\u008cÌL`\u0088¢dŐIqr\\\u0090oäõ\u0096FÎ·¤»Ŷ×h¹]ClÙ\u0080\\¦ďÌį¬řtTӺƙgQÇÓHţĒ\u0094´ÃbEÄlbʔC\u0094|C\u0088Ů\u0090\u0088\u0090k\u0084Ʈ[ʼ¬ň\u009c´KŮÈΰÌĪ¶ƶlð\u0094ļA\u0086TUvdT\u008aG\u0086º̼\u008aÔ\u0080\u008csÊDÔ\u0084veOg"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            105308,
                            37219
                        ]
                    ],
                    [
                        [
                            95370,
                            40081
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    96.778916,
                    35.623178
                ],
                "name": "青海",
                "childNum": 2
            }
        },
        {
            "id": "640000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@KëÀęĞ«Oęȿȕ\u009fı]ŉ¡åįÕÔ«Ǵõƪ\u0099ĚQÐZhv K°\u009böqÀÑ\u0090S[ÃÖHƖč\u008fË\u0087nL]ûc\u0085Ùß@\u0082\u0093ĝ\u0091¾}w»»\u008boģF¹\u009c»\u008fkÌÏ\u007f·{zP\u0083§B\u00ad¢íyÅt@\u0083\u009d@á\u009a]Yv_ssģ¼iß\u0081\u0094ĻL¾ġsKD£¡N_\u0085\u0093\u0098X\u008d¸}B\u007f~Hai\u0088\u0099\u007fÅf{«x»ge_bs\u0093KF¯¡Ix\u0099mELcÿZ¤\u00adĢ\u0091\u0083Ý\u009csuBLù\u0095t\u0086\u009d\u008cYd\u0090\u0088mVtNmtOPhRw~bd\u0085¾qÐ\\âÙH\u0081\\bImlNZ\u009f\u007f»lo\u0083\u009fqlVm\u0096Gā§~QCw¤\u0099{A\\\u008f\u0091PK\u008f\u009fNY\u0087¯bF\u0087kC¥\u0092sk\u008b\u008as_Ã\\ă«¢ħkJi¯r\u009brAhĹûç£CU\u0087ĕĊ_Ô\u0097BixÅÙ\u008fĄnªÑaM~ħp\u0081Ou¥sîeQ¥¤^dkKwlL~{L~\u0096hw^\u0082ófć\u0083KyE\u008c\u00adK\u00adzuÔ¡qQ¤xZÑ¢^ļöÜ¾Ep\u009e±âbÊÑÆ^fk¬\u0085NC¾\u0091\u008c\u0093Y\u0081pxbK~¥\u008eeÖ\u008e\u008cäBlt¿Đ\u008dx½I[ĒǙ\u008cW\u009e\u008bf»Ĭ}d§dµ\u008dùEu\u0090j¨\u0082IÆ¢¥dXªƅx¿]mtÏwßRĶ\u008cX¢͎vÆzƂZò®ǢÌʆCrâºMÞz\u009eÆMÒ\u0094ÊÓŊZÄ¾\u0096r°\u009dÎ®Ȉmª²ĈUªĚî\u0081\u0088øº\u0088Į¦ÌĘk\u0084^FłĬhĚiĀĖ¾iİbjÕ"
                    ],
                    [
                        "@@mfw\u007fěwMrŢªv@G\u0089"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            109366,
                            40242
                        ]
                    ],
                    [
                        [
                            108600,
                            36303
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    106.278179,
                    37.26637
                ],
                "name": "宁夏",
                "childNum": 2
            }
        },
        {
            "id": "650000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@QØĔ²X¨\u0094~ǘBºjʐßØvK\u0094ƔX¨vĊO\u009eÃ\u0083·¢i@\u0081~c\u0097\u0087ĝe_«\u0094E\u009a\u0093}QxgɪëÏÃ@sÅyXoŖ{ô«ŸuX\u0085ê\u0095Îf`\u008d\u009cC\u0082\u0081\u007f¹ÂÿÐGĮÕĞXŪōŸMźÈƺQèĽôe|¿ƸJR¤ĘEjcUóº¯Ĩ_ŘÁ\u008fMª÷Ð¥OéÈ\u0087\u008d¿ÖğǤǷÂFÒ\u0087zÉx[]\u00adĤĝ\u0089œ¦EP}ûƥé¿İƷTėƫœŕƅ\u0099ƱB»Đ±\u0092ēO\u0085¦E\u0096\u0095}\u0091`cȺrĦáŖuÒ\u009eª«Ĳ\u0087πdƺÏØZƴwʄ¤ĖGĐ\u0099ǂZĶ\u0083èH¶}ÚZצʥĪï|ÇĦMŔ»İĝǈ\u008bì¥Β\u009cba\u00ad¯¥ǕǚkĆŵĦɑĺƯxūД̵nơʃĽá½M»\u008d\u009bòmqóŘĝčË¾ăC\u0085ćāƿÝɽ©ǱŅ¹đ¥\u0098³ðLrÁ®ɱĕģŉǻ\u0081̋ȥơŻǛȡVï¹Ň۩ûkɗġƁ§ʇė̕ĩũƽō^ƕ\u008aUv£ƁQï\u0093Ƶkŏ½ΉÃŭÇ³LŇ\u009bʻ«ƭ\\l\u0083\u0087\u008fŭ\u008fD\u0087\u0093{ʓDkaFÃÄa\u0093³ŤđÔGRÈƚhSӹŚsİ«ĐË[¥Ú\u007fDkº^Øg¼ŵ¸£EÍö\u0095\u0080ůŉT¡c_\u0087ËKY\u008bƧUśĵ\u0084Ý\u0083U_©rETÏʜ±OñtYwē¨\u0083{£¨uM³x½şL©Ùá[ÓÐĥ Νtģ¢\\\u0082ś\u0092nkO\u009bw¥±\u0083T»ƷFɯàĩÞáB¹Æ\u008d\u0085ÑUw\u0084ŕ\u008a\u008d\u009eĽw[\u0093mG½Èå~\u0087Æ÷Qy\u008aěCFmĭZī\u0097ŵVÁ\u0099ƿQƛ\u0097ûXS²\u0089b½KÏ½ĉS\u009b©ŷXĕ\u009f{\u008eĕK·¥Ɨcqq©f¿]\u0087\u008dßDõ\u008dU³h\u0097\u00ad\u0081gËÇïģÉɋw\u0093k¯í}I·\u009aœbm\u009cÉ\u0096ř\u009bīJɥĻˁ×x\u0081o\u009bɹī\u0087l\u0095c\u0085¤³Xù]\u0091\u0099ǅA¿w͉ì¥wÇN·ÂËn\u008fƾƍdÇ§đ®Ɲv\u0095Um©³G\\\u0093}µĿ\u0087QyŹ\u008flă\u0093\u009bµEw\u0089ǇQ½yƋBe¶ŋÀů\u0087o\u009e¥A\u0097\u0098Éw@\u0095{Gpm¿Aĳ\u0086ŽKLh\u008d\u0088³`ñcËtW\u0082±»ÕS\u0089ëüÿďD\u0087u\\wwwù³\u0097V\u009b\u008dLŕ\u0083OM\u008dËGh\u0081£õP¡\u0099er\u008d\u0099Ïd{\u0093\u0087ġWÁ\u0085č|\u007fyšg\u009d^ğyÁzÙ\u007fs`\u0097s|ÉåªÇ}m¢Ń¨`x¥\u0092ù^\u0095}\u0083Ì¥H«\u0089Yªƅ\u0094AÐ¹n~ź¯\u009af¤áÀz\u0084g\u008aÇDIÔ\u009d´AňĀÒ\u0084¶ûEYospõD[{ù°]u\u009bJq\u008d\u0095U\u0095|Soċxţ[õÔĥkŋÞŭZËºóYËüċrw \u0080ÞkrťË¿XG\u008fÉbřaDü·Ē÷AÃª[Ää\u0080IÂ®BÕĐ\u0098Þ_¢āĠp\u008aÛÄȉĖġDK\u009dwb\u009dm\u0087ÄNô\u0087\u008af\u009cƫVÉvi\u0086ǳ\u0097H\u0091\u008bQµâF\u009aù\u007f\u00adÂœ³\u008d¦{YG\u009e\u0083d¢ĚÜO \u0084\u0080{Ö¦ÞÍÀP\u008c^b\u0096ƾ\u008al\u008e[\u0084vt×ĈÍEË¨¡Đ~´î¸ùÎh\u0080uè`¸\u009fHÕŔVºwĠââWò\u0087@{\u009cÙNÝ´ə²ȕn{¿¥{l\u0097÷eé^e\u0092ď\u0088Xj©î\\ªÑò\u0098Üìc\\üq\u0088Õ[\u0081Č¡xoÂċªbØ\u00ad\u008cø|\u0080¶ȴZdÆÂ\u009aońé\u008cG\u009a\\\u0094¼\u0090C°ÌÆ\u0081n´nx\u009aÊOĨ\u0092Ū\u0081ƴĸ¢¸òTxÊǪMīĞ\u0098ÖŲÃɎOv\u0088ʦƢ~F\u008e\u0087Rěò\u0097¿ġ~åŊ\u009cú\u0089N\u009a\u009e\u009a¸q\u008e\u0092Ę[Ĕ¶Âćn\u0090ÒPĒÜvúĀÊbÖ{Äî¸~Ŕünp¤ÂH¾\u009cĄYÒ©ÊfºmÔ\u0088ĘcDoĬMŬ\u0092\u0098S¤\u0084s²\u0082\u0094ʘÚ\u0086žȂVŦ \u0096\u008eèW°ªB|ĲXŔþÈJĦÆæFĚê\u008aYĂªĂ]øªŖNÞüA\u0080\u0092fɨJ\u0080\u0098¯ÎrDD\u009aĤ\u0080`\u0080mz\\\u0084§~D¬{vJ\u0090Â\u0098«lµĂb\u0096¤p\u0080ŌŰNĄ¨ĊXW|ų ¿¾ɄĦƐMT\u0094\u0087òP\u0098÷fØĶK¢ȝ˔Sô¹òEð\u00ad\u0094`Ɩ½ǒÂň×äı\u0096§ĤƝ§C~¡\u0082hlå\u0082ǺŦŞkâ\u0092~}\u008eFøàĲaĞ\u0082f\u0090Ơ¥\u008e\u0084Ŕd\u009e\u0098®U¸\u0088źX\u009cv¢aƆúŪtŠųƠjd\u0095ƺ\u008aƺÅìnrh\\ĺ¯äɝĦ]èpĄ¦´LƞĬ\u008a´ƤǬ˼Ēɸ¤rºǼ²¨zÌPðŀbþ¹ļD¢¹\u009c\\ĜÑŚ\u009f¶ZƄ³àjĨoâ\u008aȴLÊ\u0089Ȯ\u008cĐ\u00adĚă\u008eÀêZǚŐ¤qȂ\\L¢ŌİfÆs|zºeªÙæ§΢{Ā´ƐÚ¬¨Ĵà²łhʺKÞºÖT\u008aiƢ¾ªì°`öøu®Ê¾ãØ"
                ],
                "encodeOffsets": [
                    [
                        88824,
                        50096
                    ]
                ]
            },
            "properties": {
                "cp": [
                    85.617733,
                    40.792818
                ],
                "name": "新疆",
                "childNum": 1
            }
        },
        {
            "id": "110000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@ĽOÁ\u009bûtŷmiÍt_H»Ĩ±d`\u008a¹\u00ad{bw\u0085Yr\u0093³S]§§o¹\u0080qGtm_Sŧ\u0080\u0093oa\u009b\u008bFLg\u0091QN_\u0095dV\u009d\u0080@Zom_ć\\ß\u009acÂ±x¯oœRcfe\u0085£\u0092o§ËgToÛJíĔóu\u0085|\u007fwP¤\u0099Xn\u0090O¢É\u0088Ŧ\u0090¯rNÄā¤zâŖÈRpŢZ\u008a\u009cÚ{G\u008arFt¦Òx§ø¹RóäV¤\u009dXd\u0088żâºWbwŚ¨Ud®bêņ¾\u0091jnŎGŃŶ\u008anz\u008dÚSeîĜZ\u0090czî¾i]Í\u009c\u0099QaúÍÔiþĩȨWĢ\u008bü|Ėu[q\u008db[swP@ÅğP¿{\\\u0087¥A¨Ï\u0091Ñ¨\u008dj¯\u008aX\\¯\u009cMK\u0091pA³[H\u0085īu}}"
                ],
                "encodeOffsets": [
                    [
                        120023,
                        41045
                    ]
                ]
            },
            "properties": {
                "cp": [
                    116.405285,
                    39.904989
                ],
                "name": "北京",
                "childNum": 1
            }
        },
        {
            "id": "120000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@ŬgX§Ü«E\u0085¶FÌ\u0087\u007f\u0093¬O_\u0099ïlÁg\u0093z±AXe\u0099µÄĵ{\u008f¶]gitg\u009aIj·\u009b¥îakS\u0080\u0089¨ÐƎk}ĕ{gB\u0097qGf{¿a\u0086U^fI\u0093ư\u008b\u0090³õ{Y\u0083ıëNĿ\u009ek©ïËZŏ\u0091R§òoY×Ógc\u0085ĥs¡bġ«@dekąI[nlPqCnp{\u0088ō³\u009d°`\u0090{PNdƗqSÄĻNNâyj]ä\u009eÒD ĬH°Æ]~¡HO¾\u008cX}Ðx\u008cgp\u0093gW\u0088rDG\u0088\u008cpù\u0082\u008a^L\u0082\u008f\u0088rzWx\u0088Z^¨´T\\|~@I\u0089z\u0083\u0096bĤ\u008b\u009cjeĊªz£®Ĕvě\u0080L\u0086mV¾Ô_È\u0094NW~zbĬvG\u0086²ZmDM~\u0094~"
                ],
                "encodeOffsets": [
                    [
                        120237,
                        41215
                    ]
                ]
            },
            "properties": {
                "cp": [
                    117.190182,
                    39.125596
                ],
                "name": "天津",
                "childNum": 1
            }
        },
        {
            "id": "310000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@ɧư¬Ep\u0081ƸÁx\u009dc\u0087"
                    ],
                    [
                        "@@©\u0084ª\u0083"
                    ],
                    [
                        "@@\u0094MA\u008b\u0091\u009a"
                    ],
                    [
                        "@@Qpİ\u0081E§ÉC\u008d¾"
                    ],
                    [
                        "@@bŝÕ\u0095ÕEȣÚƥê\u008fIm\u0081ɇǦèÜĠ\u008cÚ\u008f\u009eÃƌÃ͎ó"
                    ],
                    [
                        "@@ǜûȬɋ\u008aŭ\u0099×^\u0089sY\u008f\u008cɍDŋ\u0091ŽąñCG²«ªč@h\u0096_p¯A{\u0087oloY\u0080¬\u007fj@Ĳ\u008d`\u0095gQÚ\u009bhr|ǀ^MĲvtbe´R¯Ô¬¨Y\u008eô¤r]ì\u0086Ƭį"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            124702,
                            32062
                        ]
                    ],
                    [
                        [
                            124547,
                            32200
                        ]
                    ],
                    [
                        [
                            124808,
                            31991
                        ]
                    ],
                    [
                        [
                            124726,
                            32110
                        ]
                    ],
                    [
                        [
                            124903,
                            32376
                        ]
                    ],
                    [
                        [
                            124438,
                            32149
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    121.472644,
                    31.231706
                ],
                "name": "上海",
                "childNum": 6
            }
        },
        {
            "id": "500000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@vjG~nGŘŬĶȂƀƾ¹\u0090\u0081¸ØÎezĆT¸}êÐ\u0096qH\u009fðqĖä\u0092\u008a¥^CÆ\u0092Ij\u0096²p\u0085\\_ æüY|\u009d[YxƊæu\u009e°xb®\u0085\u0090Űb@~¢NQt°¶\u0082Sæ \u0093Ê~rǉĔëĚ¢~\u009auf`\u0091\u0082\u0086fa\u0082ĔJåĊ\u0084nÖ]\u0084jƎćÊ@\u008a£¾a®£Ű{ŶĕF\u008bègLk{Y|¡ĜWƔtƬ\u007fJÑxq\u008b±ĢN´\u0089òK\u0089\u0099\u0096LÈÃ¼D|s`ŋ\u0092ć]\u0083Ã\u0089`đ\u008cMûƱ½~Y°ħ`ƏíW\u0089½eI\u008b½{a\u009f\u0091OIrÏ¡ĕŇa\u0086p\u0086µÜƅġ\u0091\u009c^ÖÛbÙ\u007fŽŏml½S\u008bêqDu[R\u008bãË»\u0086ÿw`»y\u0091¸_ĺę}÷`M¯ċfCVµqŉ÷Z\u0095gg\u0093\u008c`d½pDO\u0087Î\u0081Cn\u009c^uf²ènh¼WtƏxRGg¦\u0085pV\u007f\u0084\u0086FI±\u008eG^\u008cIc´ec\u0087\u0092G\u0095ĹÞ½sëĬ\u0084h\u0098xW\u0082}KÓ\u0088e\u007f\u00adXsbk\u0094F¦\u009bL\u0091ØgTkïƵNï¶}Gy\u0093w\\oñ¡nmĈzj\u009d\u009f\u0095@\u0099Óc£»Wă¹Ój\u0093_m»\u0088\u008d¹·~MvÛaq\u009c»\u00ad\u0089ê\u009c\u0092\\ÂoVn\u008eÓØÍ\u0099²«\u008d\u008bbq¿e\u0081fE \u0084\u0080\u008bĜ\u0090^Q\u009e~ Évý\u0087ş¤²Į\u0089pEİ}zcĺ\u0083L\u008b½\u0087\u009a¿gÅ\u0086\u009b¡ýE¡ya£³t\\¨\u008f\\vú»¼§·Ñr\u008f_oÒý¥u\u0082\u0095_n»_\u0083\u0095At©\u007f\u0081ÞÅ±ā§IVeë\u0083Y}{VPÀ\u0081FA¨ąB}q@|Ou\u0097\\Fm\u0089QFÝ\u0085Mw\u0098å}]\u0095\u0080\u009d|FmÏ\u008bCa\u0083w\u008cu_p\u0097¯sfÙgY\u0085DHl\u0081`{QEf\u008fNysB\u008a¦zG¸rHe\u0082\u0084N\u007f\\Cv\u007fEsÐùÜ_·ÖĉsaQ¯\u0080}_U\u0087\u0086xÃđ\u008aq\u009b\u0081NH¬\u0095Äd^ÝŰR¬ã°wećJE\u009e·vÝ·Hg\u0083\u0082éFXjÉê`|y\u008cpxkAw\u009cWĐpb¥eOsmzwqChóUQl¥F^laf\u008banòsr\u009bEvfQdÁUVf\u0097ÎvÜ^ef\u0088tET¬ôA\\\u009c¢sJ\u008enQTjPØ\u0088xøK|nBz\u0089\u0084\u009cĞ»LY\u0082\u0085FDxÓ\u0084vr\u0093[ehľ\u009a\u0095vN\u0094¢o¾NiÂxGpâ¬\u0090z\u009bbfZo~hGi\u0092]öF|\u0089|Nb\u0087tOMn eA±\u008a\u009dtPT\u0087LjpYQ|\u0086SH\u0086\u0086YĀxinzDJ\u0080Ìg¢và¥Pg\u0089_\u0096ÇzII\u008b\u0080II\u0095\u0084£®S¬\u0084ØsÎ¼\u0090£\u008cN"
                    ],
                    [
                        "@@ifjN@s"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            109628,
                            30765
                        ]
                    ],
                    [
                        [
                            111725,
                            31320
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    107.304962,
                    29.533155
                ],
                "name": "重庆",
                "childNum": 2
            }
        },
        {
            "id": "810000",
            "type": "Feature",
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        "@@AlBk"
                    ],
                    [
                        "@@m\u008en\u008d"
                    ],
                    [
                        "@@EpFo"
                    ],
                    [
                        "@@ea¢pl\u008f¸Eõ¹\u0087hj[\u0083]ÔCÎ\u0096@\u008flj\u0098¡uBX\u009f\u0085\u0081\u0095´\u008bAI¹\u0090\u0085[\u008byDU\u0088]W`çwZkmc\u0096\u0085M\u009b\u009ep\u0080Åv\u009b}I\u008boJl\u008dca\u0083fŃ\u0091K\u008e°ä¬XJmÐ đhI®æÔtSHn\u0080E\u0088\u0084ÒrÈc"
                    ],
                    [
                        "@@rMUw\u0087AS®\u0080e"
                    ]
                ],
                "encodeOffsets": [
                    [
                        [
                            117111,
                            23002
                        ]
                    ],
                    [
                        [
                            117072,
                            22876
                        ]
                    ],
                    [
                        [
                            117045,
                            22887
                        ]
                    ],
                    [
                        [
                            116975,
                            23082
                        ]
                    ],
                    [
                        [
                            116882,
                            22747
                        ]
                    ]
                ]
            },
            "properties": {
                "cp": [
                    114.173355,
                    22.320048
                ],
                "name": "香港",
                "childNum": 5
            }
        },
        {
            "id": "820000",
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    "@@kÊd\u0090°å§s"
                ],
                "encodeOffsets": [
                    [
                        116279,
                        22639
                    ]
                ]
            },
            "properties": {
                "cp": [
                    113.54909,
                    22.198951
                ],
                "name": "澳门",
                "childNum": 1
            }
        }
    ],
    "UTF8Encoding": true
}